/* tslint:disable */
/* eslint-disable */
/**
 * RIC AUTH API
 * Renewed Incentive Point AUTH API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface BPFAuthenticationRequestRequest
 */
export interface BPFAuthenticationRequestRequest {
    /**
     * Session key
     * @type {string}
     * @memberof BPFAuthenticationRequestRequest
     */
    'key': string;
}
/**
 * 
 * @export
 * @interface BPFUserInfoResponse
 */
export interface BPFUserInfoResponse {
    /**
     * 
     * @type {boolean}
     * @memberof BPFUserInfoResponse
     */
    'ok'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BPFUserInfoResponse
     */
    'error'?: string | null;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof BPFUserInfoResponse
     */
    'customerdata'?: Array<{ [key: string]: any; }>;
}
/**
 * 
 * @export
 * @interface BaccountInfo
 */
export interface BaccountInfo {
    /**
     * 
     * @type {string}
     * @memberof BaccountInfo
     */
    'iss': string;
    /**
     * 
     * @type {string}
     * @memberof BaccountInfo
     */
    'sub': string;
}
/**
 * 
 * @export
 * @interface CustomUser
 */
export interface CustomUser {
    /**
     * 
     * @type {number}
     * @memberof CustomUser
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'kanji_name': string;
    /**
     * Hiragana name in Japanese
     * @type {string}
     * @memberof CustomUser
     */
    'hiragana_name': string;
    /**
     * Which organization (client company) the user belongs to.
     * @type {number}
     * @memberof CustomUser
     */
    'organization': number;
    /**
     * ユーザーがアクティブかどうかを示します。アカウントを削除する代わりに選択を解除してください。
     * @type {boolean}
     * @memberof CustomUser
     */
    'is_active'?: boolean;
    /**
     * A short description of the user, provided by the user themselves
     * @type {string}
     * @memberof CustomUser
     */
    'bio'?: string | null;
    /**
     * User avatar. Response will be full URL
     * @type {string}
     * @memberof CustomUser
     */
    'avatar'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'group_name': string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'group_id': string;
    /**
     * ユーザーが管理サイトにログイン可能かどうかを示します。
     * @type {boolean}
     * @memberof CustomUser
     */
    'is_staff'?: boolean;
    /**
     * 全ての権限を持っているとみなされます。
     * @type {boolean}
     * @memberof CustomUser
     */
    'is_superuser'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'last_login'?: string | null;
    /**
     * Number of times user has logged in.
     * @type {number}
     * @memberof CustomUser
     */
    'login_counter'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'group_names': string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'group_ids': string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'corp_info': string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof CustomUser
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'last_name'?: string;
    /**
     * この項目は必須です。半角アルファベット、半角数字、@/./+/-/_ で150文字以下にしてください。
     * @type {string}
     * @memberof CustomUser
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'application_start_date': string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'application_end_date': string | null;
    /**
     * User login time before current login(last_login) time
     * @type {string}
     * @memberof CustomUser
     */
    'previous_last_login'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'role_name': string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'role_type': string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'role_id': string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'role_ids': string;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof CustomUser
     */
    'created_by'?: number | null;
    /**
     * The creation time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof CustomUser
     */
    'created_at': string;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof CustomUser
     */
    'updated_by'?: number | null;
    /**
     * The last update time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof CustomUser
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'organization_name': string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'usingEmployeeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'group_code': string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'role_type_display': string;
}
/**
 * 
 * @export
 * @interface CustomUserToken
 */
export interface CustomUserToken {
    /**
     * 
     * @type {number}
     * @memberof CustomUserToken
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CustomUserToken
     */
    'access_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomUserToken
     */
    'refresh_token'?: string;
}
/**
 * 
 * @export
 * @interface EmailReset
 */
export interface EmailReset {
    /**
     * 
     * @type {number}
     * @memberof EmailReset
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof EmailReset
     */
    'user': number;
    /**
     * 
     * @type {string}
     * @memberof EmailReset
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof EmailReset
     */
    'auth_code': string;
    /**
     * 
     * @type {string}
     * @memberof EmailReset
     */
    'uuid': string;
}
/**
 * 
 * @export
 * @interface EmailResetRequestRequest
 */
export interface EmailResetRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof EmailResetRequestRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof EmailResetRequestRequest
     */
    'auth_code': string;
}
/**
 * 
 * @export
 * @interface EmailResetUUID
 */
export interface EmailResetUUID {
    /**
     * 
     * @type {string}
     * @memberof EmailResetUUID
     */
    'uuid': string;
}
/**
 * 
 * @export
 * @interface Group
 */
export interface Group {
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'id': number;
    /**
     * name of the group
     * @type {string}
     * @memberof Group
     */
    'name': string;
    /**
     * companies usually have a code for the group
     * @type {string}
     * @memberof Group
     */
    'code': string;
    /**
     * which level the group is in. With the top level group being 1. For easy reference only, should be calculated from parent_group
     * @type {number}
     * @memberof Group
     */
    'hierarchy': number;
    /**
     * which organization this group belongs to
     * @type {number}
     * @memberof Group
     */
    'organization': number;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'sub_groups_count': number;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'sub_groups_ids': string;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'users_count': number;
    /**
     * The parent group. None if this is the top level group
     * @type {number}
     * @memberof Group
     */
    'parent_group'?: number | null;
    /**
     * 
     * @type {Array<SubGroup>}
     * @memberof Group
     */
    'sub_groups': Array<SubGroup>;
    /**
     * Application service start date of the group
     * @type {string}
     * @memberof Group
     */
    'application_start_date'?: string | null;
    /**
     * Application service end date of the group
     * @type {string}
     * @memberof Group
     */
    'application_end_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'recur_sub_group_ids': string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'parent_group_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'parent_group_code': string | null;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof Group
     */
    'created_by'?: number | null;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof Group
     */
    'updated_by'?: number | null;
    /**
     * The creation time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof Group
     */
    'created_at': string;
    /**
     * The last update time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof Group
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'updated_by_name': string;
}
/**
 * 
 * @export
 * @interface GroupNameOnly
 */
export interface GroupNameOnly {
    /**
     * 
     * @type {number}
     * @memberof GroupNameOnly
     */
    'id': number;
    /**
     * name of the group
     * @type {string}
     * @memberof GroupNameOnly
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface InitialInfo
 */
export interface InitialInfo {
    /**
     * 
     * @type {number}
     * @memberof InitialInfo
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof InitialInfo
     */
    'user': number;
    /**
     * 
     * @type {string}
     * @memberof InitialInfo
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof InitialInfo
     */
    'uuid': string;
}
/**
 * 
 * @export
 * @interface InitialInfoRequestRequest
 */
export interface InitialInfoRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof InitialInfoRequestRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface InitialInfoUUID
 */
export interface InitialInfoUUID {
    /**
     * 
     * @type {string}
     * @memberof InitialInfoUUID
     */
    'uuid': string;
}
/**
 * 
 * @export
 * @interface MaintenanceErrorSetting
 */
export interface MaintenanceErrorSetting {
    /**
     * 
     * @type {number}
     * @memberof MaintenanceErrorSetting
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceErrorSetting
     */
    'start_datetime': string;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceErrorSetting
     */
    'end_datetime': string;
    /**
     * title of maintenance error
     * @type {string}
     * @memberof MaintenanceErrorSetting
     */
    'title': string;
    /**
     * message of maintenance error
     * @type {string}
     * @memberof MaintenanceErrorSetting
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface Organization
 */
export interface Organization {
    /**
     * 
     * @type {number}
     * @memberof Organization
     */
    'id': number;
    /**
     * name of the organization/company
     * @type {string}
     * @memberof Organization
     */
    'name': string;
    /**
     * a unique, URL ready name of the organization name
     * @type {string}
     * @memberof Organization
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'company_code'?: string | null;
    /**
     * corp info from ICDB
     * @type {string}
     * @memberof Organization
     */
    'corp_info': string;
}
/**
 * 
 * @export
 * @interface OrganizationPaymentSetting
 */
export interface OrganizationPaymentSetting {
    /**
     * 
     * @type {number}
     * @memberof OrganizationPaymentSetting
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationPaymentSetting
     */
    'organization': number;
    /**
     * 
     * @type {TaxationCategoryEnum}
     * @memberof OrganizationPaymentSetting
     */
    'taxation_category'?: TaxationCategoryEnum;
    /**
     * 
     * @type {PointJpyRateEnum}
     * @memberof OrganizationPaymentSetting
     */
    'point_jpy_rate'?: PointJpyRateEnum;
}
/**
 * 
 * @export
 * @interface OrganizationPaymentSettingRequest
 */
export interface OrganizationPaymentSettingRequest {
    /**
     * 
     * @type {number}
     * @memberof OrganizationPaymentSettingRequest
     */
    'organization': number;
    /**
     * 
     * @type {TaxationCategoryEnum}
     * @memberof OrganizationPaymentSettingRequest
     */
    'taxation_category'?: TaxationCategoryEnum;
    /**
     * 
     * @type {PointJpyRateEnum}
     * @memberof OrganizationPaymentSettingRequest
     */
    'point_jpy_rate'?: PointJpyRateEnum;
}
/**
 * 
 * @export
 * @interface OrganizationRequest
 */
export interface OrganizationRequest {
    /**
     * name of the organization/company
     * @type {string}
     * @memberof OrganizationRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationRequest
     */
    'company_code'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationRequest
     */
    'permission_template'?: number;
    /**
     * corp info from ICDB
     * @type {string}
     * @memberof OrganizationRequest
     */
    'corp_info': string;
}
/**
 * 
 * @export
 * @interface PaginatedCustomUserList
 */
export interface PaginatedCustomUserList {
    /**
     * Total number of the result
     * @type {number}
     * @memberof PaginatedCustomUserList
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof PaginatedCustomUserList
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof PaginatedCustomUserList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<CustomUser>}
     * @memberof PaginatedCustomUserList
     */
    'results'?: Array<CustomUser>;
}
/**
 * 
 * @export
 * @interface PaginatedCustomUserTokenList
 */
export interface PaginatedCustomUserTokenList {
    /**
     * Total number of the result
     * @type {number}
     * @memberof PaginatedCustomUserTokenList
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof PaginatedCustomUserTokenList
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof PaginatedCustomUserTokenList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<CustomUserToken>}
     * @memberof PaginatedCustomUserTokenList
     */
    'results'?: Array<CustomUserToken>;
}
/**
 * 
 * @export
 * @interface PaginatedGroupList
 */
export interface PaginatedGroupList {
    /**
     * Total number of the result
     * @type {number}
     * @memberof PaginatedGroupList
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof PaginatedGroupList
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof PaginatedGroupList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<Group>}
     * @memberof PaginatedGroupList
     */
    'results'?: Array<Group>;
}
/**
 * 
 * @export
 * @interface PaginatedMaintenanceErrorSettingList
 */
export interface PaginatedMaintenanceErrorSettingList {
    /**
     * Total number of the result
     * @type {number}
     * @memberof PaginatedMaintenanceErrorSettingList
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof PaginatedMaintenanceErrorSettingList
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof PaginatedMaintenanceErrorSettingList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<MaintenanceErrorSetting>}
     * @memberof PaginatedMaintenanceErrorSettingList
     */
    'results'?: Array<MaintenanceErrorSetting>;
}
/**
 * 
 * @export
 * @interface PaginatedOrganizationList
 */
export interface PaginatedOrganizationList {
    /**
     * Total number of the result
     * @type {number}
     * @memberof PaginatedOrganizationList
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof PaginatedOrganizationList
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof PaginatedOrganizationList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<Organization>}
     * @memberof PaginatedOrganizationList
     */
    'results'?: Array<Organization>;
}
/**
 * 
 * @export
 * @interface PaginatedOrganizationPaymentSettingList
 */
export interface PaginatedOrganizationPaymentSettingList {
    /**
     * Total number of the result
     * @type {number}
     * @memberof PaginatedOrganizationPaymentSettingList
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof PaginatedOrganizationPaymentSettingList
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof PaginatedOrganizationPaymentSettingList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<OrganizationPaymentSetting>}
     * @memberof PaginatedOrganizationPaymentSettingList
     */
    'results'?: Array<OrganizationPaymentSetting>;
}
/**
 * 
 * @export
 * @interface PaginatedPasswordReminderList
 */
export interface PaginatedPasswordReminderList {
    /**
     * Total number of the result
     * @type {number}
     * @memberof PaginatedPasswordReminderList
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof PaginatedPasswordReminderList
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof PaginatedPasswordReminderList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<PasswordReminder>}
     * @memberof PaginatedPasswordReminderList
     */
    'results'?: Array<PasswordReminder>;
}
/**
 * 
 * @export
 * @interface PaginatedPasswordReminderQuestionsList
 */
export interface PaginatedPasswordReminderQuestionsList {
    /**
     * Total number of the result
     * @type {number}
     * @memberof PaginatedPasswordReminderQuestionsList
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof PaginatedPasswordReminderQuestionsList
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof PaginatedPasswordReminderQuestionsList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<PasswordReminderQuestions>}
     * @memberof PaginatedPasswordReminderQuestionsList
     */
    'results'?: Array<PasswordReminderQuestions>;
}
/**
 * 
 * @export
 * @interface PaginatedRoleList
 */
export interface PaginatedRoleList {
    /**
     * Total number of the result
     * @type {number}
     * @memberof PaginatedRoleList
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof PaginatedRoleList
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof PaginatedRoleList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<Role>}
     * @memberof PaginatedRoleList
     */
    'results'?: Array<Role>;
}
/**
 * 
 * @export
 * @interface PaginatedRolePermissionList
 */
export interface PaginatedRolePermissionList {
    /**
     * Total number of the result
     * @type {number}
     * @memberof PaginatedRolePermissionList
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof PaginatedRolePermissionList
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof PaginatedRolePermissionList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<RolePermission>}
     * @memberof PaginatedRolePermissionList
     */
    'results'?: Array<RolePermission>;
}
/**
 * 
 * @export
 * @interface PaginatedServiceErrorSettingList
 */
export interface PaginatedServiceErrorSettingList {
    /**
     * Total number of the result
     * @type {number}
     * @memberof PaginatedServiceErrorSettingList
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof PaginatedServiceErrorSettingList
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof PaginatedServiceErrorSettingList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<ServiceErrorSetting>}
     * @memberof PaginatedServiceErrorSettingList
     */
    'results'?: Array<ServiceErrorSetting>;
}
/**
 * 
 * @export
 * @interface PaginatedUserGroupRoleList
 */
export interface PaginatedUserGroupRoleList {
    /**
     * Total number of the result
     * @type {number}
     * @memberof PaginatedUserGroupRoleList
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof PaginatedUserGroupRoleList
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof PaginatedUserGroupRoleList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UserGroupRole>}
     * @memberof PaginatedUserGroupRoleList
     */
    'results'?: Array<UserGroupRole>;
}
/**
 * 
 * @export
 * @interface PasswordReminder
 */
export interface PasswordReminder {
    /**
     * 
     * @type {number}
     * @memberof PasswordReminder
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof PasswordReminder
     */
    'user': number;
    /**
     * 
     * @type {number}
     * @memberof PasswordReminder
     */
    'question': number;
    /**
     * 
     * @type {string}
     * @memberof PasswordReminder
     */
    'answer': string;
}
/**
 * 
 * @export
 * @interface PasswordReminderQuestions
 */
export interface PasswordReminderQuestions {
    /**
     * 
     * @type {number}
     * @memberof PasswordReminderQuestions
     */
    'id': number;
    /**
     * If not set, it\'ll be used by all clients with \'custom password reminder questions\' feature disabled
     * @type {number}
     * @memberof PasswordReminderQuestions
     */
    'organization'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PasswordReminderQuestions
     */
    'question': string;
}
/**
 * 
 * @export
 * @interface PasswordReminderRequest
 */
export interface PasswordReminderRequest {
    /**
     * 
     * @type {number}
     * @memberof PasswordReminderRequest
     */
    'user': number;
    /**
     * 
     * @type {number}
     * @memberof PasswordReminderRequest
     */
    'question': number;
    /**
     * 
     * @type {string}
     * @memberof PasswordReminderRequest
     */
    'answer': string;
}
/**
 * 
 * @export
 * @interface PatchedEmailResetRequest
 */
export interface PatchedEmailResetRequest {
    /**
     * 
     * @type {number}
     * @memberof PatchedEmailResetRequest
     */
    'user'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedEmailResetRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedEmailResetRequest
     */
    'auth_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedEmailResetRequest
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface PatchedEmailResetUUIDRequest
 */
export interface PatchedEmailResetUUIDRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedEmailResetUUIDRequest
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface PatchedInitialInfoUUIDRequest
 */
export interface PatchedInitialInfoUUIDRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedInitialInfoUUIDRequest
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface PatchedOrganizationPaymentSettingRequest
 */
export interface PatchedOrganizationPaymentSettingRequest {
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationPaymentSettingRequest
     */
    'organization'?: number;
    /**
     * 
     * @type {TaxationCategoryEnum}
     * @memberof PatchedOrganizationPaymentSettingRequest
     */
    'taxation_category'?: TaxationCategoryEnum;
    /**
     * 
     * @type {PointJpyRateEnum}
     * @memberof PatchedOrganizationPaymentSettingRequest
     */
    'point_jpy_rate'?: PointJpyRateEnum;
}
/**
 * 
 * @export
 * @interface PatchedOrganizationRequest
 */
export interface PatchedOrganizationRequest {
    /**
     * name of the organization/company
     * @type {string}
     * @memberof PatchedOrganizationRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrganizationRequest
     */
    'company_code'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationRequest
     */
    'permission_template'?: number;
    /**
     * corp info from ICDB
     * @type {string}
     * @memberof PatchedOrganizationRequest
     */
    'corp_info'?: string;
}
/**
 * 
 * @export
 * @interface PatchedPasswordReminderRequest
 */
export interface PatchedPasswordReminderRequest {
    /**
     * 
     * @type {number}
     * @memberof PatchedPasswordReminderRequest
     */
    'user'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedPasswordReminderRequest
     */
    'question'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedPasswordReminderRequest
     */
    'answer'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PermissionEnum = {
    NUMBER_10101: 10101,
    NUMBER_110101: 110101,
    NUMBER_110201: 110201,
    NUMBER_110301: 110301,
    NUMBER_210101: 210101,
    NUMBER_210201: 210201,
    NUMBER_210202: 210202,
    NUMBER_210203: 210203,
    NUMBER_210204: 210204,
    NUMBER_210205: 210205,
    NUMBER_210301: 210301,
    NUMBER_210302: 210302,
    NUMBER_210303: 210303,
    NUMBER_220101: 220101,
    NUMBER_220102: 220102,
    NUMBER_230101: 230101,
    NUMBER_230102: 230102,
    NUMBER_310101: 310101,
    NUMBER_310102: 310102,
    NUMBER_310103: 310103,
    NUMBER_310104: 310104,
    NUMBER_310105: 310105,
    NUMBER_310201: 310201,
    NUMBER_310301: 310301,
    NUMBER_310401: 310401,
    NUMBER_310501: 310501,
    NUMBER_310502: 310502,
    NUMBER_310503: 310503,
    NUMBER_310504: 310504,
    NUMBER_410101: 410101,
    NUMBER_410102: 410102,
    NUMBER_410103: 410103,
    NUMBER_410104: 410104,
    NUMBER_420101: 420101,
    NUMBER_420201: 420201,
    NUMBER_430101: 430101,
    NUMBER_430102: 430102,
    NUMBER_430201: 430201,
    NUMBER_430202: 430202,
    NUMBER_440101: 440101,
    NUMBER_440102: 440102,
    NUMBER_440103: 440103,
    NUMBER_440201: 440201,
    NUMBER_440301: 440301,
    NUMBER_440401: 440401,
    NUMBER_440402: 440402,
    NUMBER_440403: 440403,
    NUMBER_440501: 440501,
    NUMBER_440601: 440601,
    NUMBER_510101: 510101,
    NUMBER_510201: 510201,
    NUMBER_710101: 710101,
    NUMBER_710102: 710102,
    NUMBER_710103: 710103,
    NUMBER_810101: 810101,
    NUMBER_810201: 810201,
    NUMBER_810301: 810301,
    NUMBER_810401: 810401,
    NUMBER_810501: 810501,
    NUMBER_810601: 810601,
    NUMBER_810701: 810701,
    NUMBER_810801: 810801,
    NUMBER_810901: 810901,
    NUMBER_811001: 811001,
    NUMBER_811101: 811101,
    NUMBER_811201: 811201,
    NUMBER_811301: 811301,
    NUMBER_811401: 811401,
    NUMBER_811501: 811501,
    NUMBER_811601: 811601,
    NUMBER_810902: 810902,
    NUMBER_910101: 910101,
    NUMBER_910201: 910201,
    NUMBER_910301: 910301,
    NUMBER_910401: 910401,
    NUMBER_910501: 910501,
    NUMBER_910601: 910601,
    NUMBER_910701: 910701,
    NUMBER_910801: 910801,
    NUMBER_910802: 910802,
    NUMBER_910901: 910901,
    NUMBER_911001: 911001,
    NUMBER_911101: 911101,
    NUMBER_911201: 911201
} as const;

export type PermissionEnum = typeof PermissionEnum[keyof typeof PermissionEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const PointJpyRateEnum = {
    NUMBER_1: 1,
    NUMBER_5: 5,
    NUMBER_10: 10,
    NUMBER_50: 50,
    NUMBER_100: 100,
    NUMBER_2000: 2000
} as const;

export type PointJpyRateEnum = typeof PointJpyRateEnum[keyof typeof PointJpyRateEnum];


/**
 * Serializer for the JWT token auth response  Define the response so that OpenAPI tool chain can generate client code correctly
 * @export
 * @interface RicAuthTokenObtainResponse
 */
export interface RicAuthTokenObtainResponse {
    /**
     * The Access token client code can use to access resources
     * @type {string}
     * @memberof RicAuthTokenObtainResponse
     */
    'access': string;
    /**
     * The Refresh token that client code can use to get new JWT pair
     * @type {string}
     * @memberof RicAuthTokenObtainResponse
     */
    'refresh': string;
}
/**
 * 
 * @export
 * @interface Role
 */
export interface Role {
    /**
     * 
     * @type {number}
     * @memberof Role
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof Role
     */
    'organization': number;
    /**
     * 
     * @type {RoleTypeEnum}
     * @memberof Role
     */
    'role_type': RoleTypeEnum;
}
/**
 * 
 * @export
 * @interface RolePermission
 */
export interface RolePermission {
    /**
     * 
     * @type {number}
     * @memberof RolePermission
     */
    'id': number;
    /**
     * 
     * @type {PermissionEnum}
     * @memberof RolePermission
     */
    'permission': PermissionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof RolePermission
     */
    'read'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RolePermission
     */
    'create'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RolePermission
     */
    'update'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RolePermission
     */
    'delete'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RoleTypeEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5
} as const;

export type RoleTypeEnum = typeof RoleTypeEnum[keyof typeof RoleTypeEnum];


/**
 * 
 * @export
 * @interface ServiceErrorSetting
 */
export interface ServiceErrorSetting {
    /**
     * 
     * @type {number}
     * @memberof ServiceErrorSetting
     */
    'id': number;
    /**
     * stat time of service error
     * @type {string}
     * @memberof ServiceErrorSetting
     */
    'start_time': string;
    /**
     * end time of service error
     * @type {string}
     * @memberof ServiceErrorSetting
     */
    'end_time': string;
    /**
     * title of service error
     * @type {string}
     * @memberof ServiceErrorSetting
     */
    'title': string;
    /**
     * message of service error
     * @type {string}
     * @memberof ServiceErrorSetting
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface SubGroup
 */
export interface SubGroup {
    /**
     * 
     * @type {number}
     * @memberof SubGroup
     */
    'id': number;
    /**
     * name of the group
     * @type {string}
     * @memberof SubGroup
     */
    'name': string;
    /**
     * companies usually have a code for the group
     * @type {string}
     * @memberof SubGroup
     */
    'code': string;
    /**
     * which level the group is in. With the top level group being 1. For easy reference only, should be calculated from parent_group
     * @type {number}
     * @memberof SubGroup
     */
    'hierarchy': number;
    /**
     * 
     * @type {number}
     * @memberof SubGroup
     */
    'sub_groups_count': number;
    /**
     * 
     * @type {number}
     * @memberof SubGroup
     */
    'users_count': number;
    /**
     * 
     * @type {string}
     * @memberof SubGroup
     */
    'sub_groups_ids': string;
    /**
     * Application service start date of the group
     * @type {string}
     * @memberof SubGroup
     */
    'application_start_date'?: string | null;
    /**
     * Application service end date of the group
     * @type {string}
     * @memberof SubGroup
     */
    'application_end_date'?: string | null;
}
/**
 * 
 * @export
 * @interface SwitchSite
 */
export interface SwitchSite {
    /**
     * which site to go to
     * @type {ToSiteEnum}
     * @memberof SwitchSite
     */
    'to_site': ToSiteEnum;
    /**
     * Redirect to this URL to go to the desired site
     * @type {string}
     * @memberof SwitchSite
     */
    'redirect_url': string;
}
/**
 * 
 * @export
 * @interface SwitchSiteRequest
 */
export interface SwitchSiteRequest {
    /**
     * which site to go to
     * @type {ToSiteEnum}
     * @memberof SwitchSiteRequest
     */
    'to_site': ToSiteEnum;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TaxationCategoryEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type TaxationCategoryEnum = typeof TaxationCategoryEnum[keyof typeof TaxationCategoryEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const ToSiteEnum = {
    Admin: 'admin',
    General: 'general'
} as const;

export type ToSiteEnum = typeof ToSiteEnum[keyof typeof ToSiteEnum];


/**
 * 
 * @export
 * @interface TokenObtainPairRequest
 */
export interface TokenObtainPairRequest {
    /**
     * 
     * @type {string}
     * @memberof TokenObtainPairRequest
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof TokenObtainPairRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface TokenRefreshRequest
 */
export interface TokenRefreshRequest {
    /**
     * 
     * @type {string}
     * @memberof TokenRefreshRequest
     */
    'refresh': string;
}
/**
 * 
 * @export
 * @interface UserGroupRole
 */
export interface UserGroupRole {
    /**
     * 
     * @type {number}
     * @memberof UserGroupRole
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof UserGroupRole
     */
    'user': number;
    /**
     * 
     * @type {GroupNameOnly}
     * @memberof UserGroupRole
     */
    'group': GroupNameOnly;
    /**
     * 
     * @type {Role}
     * @memberof UserGroupRole
     */
    'role': Role;
}
/**
 * 
 * @export
 * @interface UserGroupRoleResponse
 */
export interface UserGroupRoleResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupRoleResponse
     */
    'is_group_admin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupRoleResponse
     */
    'is_manager': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupRoleResponse
     */
    'is_reseller_admin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupRoleResponse
     */
    'is_normal_user': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupRoleResponse
     */
    'is_default_normal_user': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupRoleResponse
     */
    'is_master_admin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupRoleResponse
     */
    'is_staff_user': boolean;
}
/**
 * Use to handle the data validation and check the Api-Key is valid
 * @export
 * @interface ValidateApiKeyRequest
 */
export interface ValidateApiKeyRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidateApiKeyRequest
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof ValidateApiKeyRequest
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateApiKeyRequest
     */
    'domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateApiKeyRequest
     */
    'request_from'?: string;
}
/**
 * Use to generate APi return response for APi-client
 * @export
 * @interface ValidateApiKeyResponse
 */
export interface ValidateApiKeyResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidateApiKeyResponse
     */
    'is_valid_key': boolean;
}

/**
 * BpfLoginApi - axios parameter creator
 * @export
 */
export const BpfLoginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {BPFAuthenticationRequestRequest} bPFAuthenticationRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bpfLoginCreate: async (bPFAuthenticationRequestRequest: BPFAuthenticationRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bPFAuthenticationRequestRequest' is not null or undefined
            assertParamExists('bpfLoginCreate', 'bPFAuthenticationRequestRequest', bPFAuthenticationRequestRequest)
            const localVarPath = `/api/bpf_login/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bPFAuthenticationRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BpfLoginApi - functional programming interface
 * @export
 */
export const BpfLoginApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BpfLoginApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {BPFAuthenticationRequestRequest} bPFAuthenticationRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bpfLoginCreate(bPFAuthenticationRequestRequest: BPFAuthenticationRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RicAuthTokenObtainResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bpfLoginCreate(bPFAuthenticationRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BpfLoginApi - factory interface
 * @export
 */
export const BpfLoginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BpfLoginApiFp(configuration)
    return {
        /**
         * 
         * @param {BPFAuthenticationRequestRequest} bPFAuthenticationRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bpfLoginCreate(bPFAuthenticationRequestRequest: BPFAuthenticationRequestRequest, options?: any): AxiosPromise<RicAuthTokenObtainResponse> {
            return localVarFp.bpfLoginCreate(bPFAuthenticationRequestRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BpfLoginApi - object-oriented interface
 * @export
 * @class BpfLoginApi
 * @extends {BaseAPI}
 */
export class BpfLoginApi extends BaseAPI {
    /**
     * 
     * @param {BPFAuthenticationRequestRequest} bPFAuthenticationRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BpfLoginApi
     */
    public bpfLoginCreate(bPFAuthenticationRequestRequest: BPFAuthenticationRequestRequest, options?: AxiosRequestConfig) {
        return BpfLoginApiFp(this.configuration).bpfLoginCreate(bPFAuthenticationRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomUserApi - axios parameter creator
 * @export
 */
export const CustomUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that return what permission does the user have in a given group.
         * @param {string} group ID of the group to query
         * @param {number} id A unique integer value identifying this ユーザー.
         * @param {string} [excludeCurrentUser] Specify whether to exclude current user or not
         * @param {string} [groupIds] Filter by group ids. Values can be comma separated. ex: 1,2
         * @param {string} [hiraganaName] hiragana_name
         * @param {string} [isDeleted] is_deleted
         * @param {string} [kanjiname] kanjiname
         * @param {string} [nestedUsers] nested_users
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [organization] organization
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [roleType] role_type
         * @param {string} [search] A search term.
         * @param {'user_info' | 'user_and_group_info'} [searchPattern] Choose which pattern to use when searching.
         * @param {string} [username] username
         * @param {string} [usingEmployeeId] using_employee_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customUserGetGroupPermissionsList: async (group: string, id: number, excludeCurrentUser?: string, groupIds?: string, hiraganaName?: string, isDeleted?: string, kanjiname?: string, nestedUsers?: string, ordering?: string, organization?: string, page?: number, pageSize?: number, roleType?: string, search?: string, searchPattern?: 'user_info' | 'user_and_group_info', username?: string, usingEmployeeId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'group' is not null or undefined
            assertParamExists('customUserGetGroupPermissionsList', 'group', group)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customUserGetGroupPermissionsList', 'id', id)
            const localVarPath = `/api/CustomUser/{id}/get_group_permissions/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (excludeCurrentUser !== undefined) {
                localVarQueryParameter['exclude_current_user'] = excludeCurrentUser;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }

            if (groupIds !== undefined) {
                localVarQueryParameter['group_ids'] = groupIds;
            }

            if (hiraganaName !== undefined) {
                localVarQueryParameter['hiragana_name'] = hiraganaName;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['is_deleted'] = isDeleted;
            }

            if (kanjiname !== undefined) {
                localVarQueryParameter['kanjiname'] = kanjiname;
            }

            if (nestedUsers !== undefined) {
                localVarQueryParameter['nested_users'] = nestedUsers;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (organization !== undefined) {
                localVarQueryParameter['organization'] = organization;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (roleType !== undefined) {
                localVarQueryParameter['role_type'] = roleType;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchPattern !== undefined) {
                localVarQueryParameter['search_pattern'] = searchPattern;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (usingEmployeeId !== undefined) {
                localVarQueryParameter['using_employee_id'] = usingEmployeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to return user details.  Possible ordering fields are `username`, `kanjiname`, and `id`.  Possible filtering fields are documented below. - `kanjiname`, `organization`, `hiragana_name`, `group_ids`, and `exclude_current_user`.  If the selected search pattern is user_info or no search pattern is selected search will be performed on the `kanjiname`, `hiragana_name`, and `ID` of the user.  If the selected search pattern is user_and_group_info, search will be performed on `kanjiname`, `hiragana_name`, `id` of user and `group__name`, and `group__code` of group.  For GET and PATCH API calls, pass in id `0` for the current logged in user.
         * @param {number} groupId ID of the group to query
         * @param {number} id A unique integer value identifying this ユーザー.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customUserGetUserGroupRoleRetrieve: async (groupId: number, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('customUserGetUserGroupRoleRetrieve', 'groupId', groupId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customUserGetUserGroupRoleRetrieve', 'id', id)
            const localVarPath = `/api/CustomUser/{id}/get_user_group_role/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to return user details.  Possible ordering fields are `username`, `kanjiname`, and `id`.  Possible filtering fields are documented below. - `kanjiname`, `organization`, `hiragana_name`, `group_ids`, and `exclude_current_user`.  If the selected search pattern is user_info or no search pattern is selected search will be performed on the `kanjiname`, `hiragana_name`, and `ID` of the user.  If the selected search pattern is user_and_group_info, search will be performed on `kanjiname`, `hiragana_name`, `id` of user and `group__name`, and `group__code` of group.  For GET and PATCH API calls, pass in id `0` for the current logged in user.
         * @param {string} [excludeCurrentUser] Specify whether to exclude current user or not
         * @param {string} [groupIds] Filter by group ids. Values can be comma separated. ex: 1,2
         * @param {string} [hiraganaName] hiragana_name
         * @param {string} [isDeleted] is_deleted
         * @param {string} [kanjiname] kanjiname
         * @param {string} [nestedUsers] nested_users
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [organization] organization
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [roleType] role_type
         * @param {string} [search] A search term.
         * @param {'user_info' | 'user_and_group_info'} [searchPattern] Choose which pattern to use when searching.
         * @param {string} [username] username
         * @param {string} [usingEmployeeId] using_employee_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customUserList: async (excludeCurrentUser?: string, groupIds?: string, hiraganaName?: string, isDeleted?: string, kanjiname?: string, nestedUsers?: string, ordering?: string, organization?: string, page?: number, pageSize?: number, roleType?: string, search?: string, searchPattern?: 'user_info' | 'user_and_group_info', username?: string, usingEmployeeId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CustomUser/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (excludeCurrentUser !== undefined) {
                localVarQueryParameter['exclude_current_user'] = excludeCurrentUser;
            }

            if (groupIds !== undefined) {
                localVarQueryParameter['group_ids'] = groupIds;
            }

            if (hiraganaName !== undefined) {
                localVarQueryParameter['hiragana_name'] = hiraganaName;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['is_deleted'] = isDeleted;
            }

            if (kanjiname !== undefined) {
                localVarQueryParameter['kanjiname'] = kanjiname;
            }

            if (nestedUsers !== undefined) {
                localVarQueryParameter['nested_users'] = nestedUsers;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (organization !== undefined) {
                localVarQueryParameter['organization'] = organization;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (roleType !== undefined) {
                localVarQueryParameter['role_type'] = roleType;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchPattern !== undefined) {
                localVarQueryParameter['search_pattern'] = searchPattern;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (usingEmployeeId !== undefined) {
                localVarQueryParameter['using_employee_id'] = usingEmployeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to return user details.  Possible ordering fields are `username`, `kanjiname`, and `id`.  Possible filtering fields are documented below. - `kanjiname`, `organization`, `hiragana_name`, `group_ids`, and `exclude_current_user`.  If the selected search pattern is user_info or no search pattern is selected search will be performed on the `kanjiname`, `hiragana_name`, and `ID` of the user.  If the selected search pattern is user_and_group_info, search will be performed on `kanjiname`, `hiragana_name`, `id` of user and `group__name`, and `group__code` of group.  For GET and PATCH API calls, pass in id `0` for the current logged in user.
         * @param {number} id A unique integer value identifying this ユーザー.
         * @param {string} [bio] A short description of the user, provided by the user themselves
         * @param {File} [avatar] User avatar. Response will be full URL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customUserPartialUpdate: async (id: number, bio?: string, avatar?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customUserPartialUpdate', 'id', id)
            const localVarPath = `/api/CustomUser/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (bio !== undefined) { 
                localVarFormParams.append('bio', bio as any);
            }
    
            if (avatar !== undefined) { 
                localVarFormParams.append('avatar', avatar as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to return user details.  Possible ordering fields are `username`, `kanjiname`, and `id`.  Possible filtering fields are documented below. - `kanjiname`, `organization`, `hiragana_name`, `group_ids`, and `exclude_current_user`.  If the selected search pattern is user_info or no search pattern is selected search will be performed on the `kanjiname`, `hiragana_name`, and `ID` of the user.  If the selected search pattern is user_and_group_info, search will be performed on `kanjiname`, `hiragana_name`, `id` of user and `group__name`, and `group__code` of group.  For GET and PATCH API calls, pass in id `0` for the current logged in user.
         * @param {number} id A unique integer value identifying this ユーザー.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customUserRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customUserRetrieve', 'id', id)
            const localVarPath = `/api/CustomUser/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomUserApi - functional programming interface
 * @export
 */
export const CustomUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomUserApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that return what permission does the user have in a given group.
         * @param {string} group ID of the group to query
         * @param {number} id A unique integer value identifying this ユーザー.
         * @param {string} [excludeCurrentUser] Specify whether to exclude current user or not
         * @param {string} [groupIds] Filter by group ids. Values can be comma separated. ex: 1,2
         * @param {string} [hiraganaName] hiragana_name
         * @param {string} [isDeleted] is_deleted
         * @param {string} [kanjiname] kanjiname
         * @param {string} [nestedUsers] nested_users
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [organization] organization
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [roleType] role_type
         * @param {string} [search] A search term.
         * @param {'user_info' | 'user_and_group_info'} [searchPattern] Choose which pattern to use when searching.
         * @param {string} [username] username
         * @param {string} [usingEmployeeId] using_employee_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customUserGetGroupPermissionsList(group: string, id: number, excludeCurrentUser?: string, groupIds?: string, hiraganaName?: string, isDeleted?: string, kanjiname?: string, nestedUsers?: string, ordering?: string, organization?: string, page?: number, pageSize?: number, roleType?: string, search?: string, searchPattern?: 'user_info' | 'user_and_group_info', username?: string, usingEmployeeId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedRolePermissionList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customUserGetGroupPermissionsList(group, id, excludeCurrentUser, groupIds, hiraganaName, isDeleted, kanjiname, nestedUsers, ordering, organization, page, pageSize, roleType, search, searchPattern, username, usingEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API to return user details.  Possible ordering fields are `username`, `kanjiname`, and `id`.  Possible filtering fields are documented below. - `kanjiname`, `organization`, `hiragana_name`, `group_ids`, and `exclude_current_user`.  If the selected search pattern is user_info or no search pattern is selected search will be performed on the `kanjiname`, `hiragana_name`, and `ID` of the user.  If the selected search pattern is user_and_group_info, search will be performed on `kanjiname`, `hiragana_name`, `id` of user and `group__name`, and `group__code` of group.  For GET and PATCH API calls, pass in id `0` for the current logged in user.
         * @param {number} groupId ID of the group to query
         * @param {number} id A unique integer value identifying this ユーザー.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customUserGetUserGroupRoleRetrieve(groupId: number, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGroupRoleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customUserGetUserGroupRoleRetrieve(groupId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API to return user details.  Possible ordering fields are `username`, `kanjiname`, and `id`.  Possible filtering fields are documented below. - `kanjiname`, `organization`, `hiragana_name`, `group_ids`, and `exclude_current_user`.  If the selected search pattern is user_info or no search pattern is selected search will be performed on the `kanjiname`, `hiragana_name`, and `ID` of the user.  If the selected search pattern is user_and_group_info, search will be performed on `kanjiname`, `hiragana_name`, `id` of user and `group__name`, and `group__code` of group.  For GET and PATCH API calls, pass in id `0` for the current logged in user.
         * @param {string} [excludeCurrentUser] Specify whether to exclude current user or not
         * @param {string} [groupIds] Filter by group ids. Values can be comma separated. ex: 1,2
         * @param {string} [hiraganaName] hiragana_name
         * @param {string} [isDeleted] is_deleted
         * @param {string} [kanjiname] kanjiname
         * @param {string} [nestedUsers] nested_users
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [organization] organization
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [roleType] role_type
         * @param {string} [search] A search term.
         * @param {'user_info' | 'user_and_group_info'} [searchPattern] Choose which pattern to use when searching.
         * @param {string} [username] username
         * @param {string} [usingEmployeeId] using_employee_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customUserList(excludeCurrentUser?: string, groupIds?: string, hiraganaName?: string, isDeleted?: string, kanjiname?: string, nestedUsers?: string, ordering?: string, organization?: string, page?: number, pageSize?: number, roleType?: string, search?: string, searchPattern?: 'user_info' | 'user_and_group_info', username?: string, usingEmployeeId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCustomUserList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customUserList(excludeCurrentUser, groupIds, hiraganaName, isDeleted, kanjiname, nestedUsers, ordering, organization, page, pageSize, roleType, search, searchPattern, username, usingEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API to return user details.  Possible ordering fields are `username`, `kanjiname`, and `id`.  Possible filtering fields are documented below. - `kanjiname`, `organization`, `hiragana_name`, `group_ids`, and `exclude_current_user`.  If the selected search pattern is user_info or no search pattern is selected search will be performed on the `kanjiname`, `hiragana_name`, and `ID` of the user.  If the selected search pattern is user_and_group_info, search will be performed on `kanjiname`, `hiragana_name`, `id` of user and `group__name`, and `group__code` of group.  For GET and PATCH API calls, pass in id `0` for the current logged in user.
         * @param {number} id A unique integer value identifying this ユーザー.
         * @param {string} [bio] A short description of the user, provided by the user themselves
         * @param {File} [avatar] User avatar. Response will be full URL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customUserPartialUpdate(id: number, bio?: string, avatar?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customUserPartialUpdate(id, bio, avatar, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API to return user details.  Possible ordering fields are `username`, `kanjiname`, and `id`.  Possible filtering fields are documented below. - `kanjiname`, `organization`, `hiragana_name`, `group_ids`, and `exclude_current_user`.  If the selected search pattern is user_info or no search pattern is selected search will be performed on the `kanjiname`, `hiragana_name`, and `ID` of the user.  If the selected search pattern is user_and_group_info, search will be performed on `kanjiname`, `hiragana_name`, `id` of user and `group__name`, and `group__code` of group.  For GET and PATCH API calls, pass in id `0` for the current logged in user.
         * @param {number} id A unique integer value identifying this ユーザー.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customUserRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customUserRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomUserApi - factory interface
 * @export
 */
export const CustomUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomUserApiFp(configuration)
    return {
        /**
         * API endpoint that return what permission does the user have in a given group.
         * @param {string} group ID of the group to query
         * @param {number} id A unique integer value identifying this ユーザー.
         * @param {string} [excludeCurrentUser] Specify whether to exclude current user or not
         * @param {string} [groupIds] Filter by group ids. Values can be comma separated. ex: 1,2
         * @param {string} [hiraganaName] hiragana_name
         * @param {string} [isDeleted] is_deleted
         * @param {string} [kanjiname] kanjiname
         * @param {string} [nestedUsers] nested_users
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [organization] organization
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [roleType] role_type
         * @param {string} [search] A search term.
         * @param {'user_info' | 'user_and_group_info'} [searchPattern] Choose which pattern to use when searching.
         * @param {string} [username] username
         * @param {string} [usingEmployeeId] using_employee_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customUserGetGroupPermissionsList(group: string, id: number, excludeCurrentUser?: string, groupIds?: string, hiraganaName?: string, isDeleted?: string, kanjiname?: string, nestedUsers?: string, ordering?: string, organization?: string, page?: number, pageSize?: number, roleType?: string, search?: string, searchPattern?: 'user_info' | 'user_and_group_info', username?: string, usingEmployeeId?: string, options?: any): AxiosPromise<PaginatedRolePermissionList> {
            return localVarFp.customUserGetGroupPermissionsList(group, id, excludeCurrentUser, groupIds, hiraganaName, isDeleted, kanjiname, nestedUsers, ordering, organization, page, pageSize, roleType, search, searchPattern, username, usingEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * API to return user details.  Possible ordering fields are `username`, `kanjiname`, and `id`.  Possible filtering fields are documented below. - `kanjiname`, `organization`, `hiragana_name`, `group_ids`, and `exclude_current_user`.  If the selected search pattern is user_info or no search pattern is selected search will be performed on the `kanjiname`, `hiragana_name`, and `ID` of the user.  If the selected search pattern is user_and_group_info, search will be performed on `kanjiname`, `hiragana_name`, `id` of user and `group__name`, and `group__code` of group.  For GET and PATCH API calls, pass in id `0` for the current logged in user.
         * @param {number} groupId ID of the group to query
         * @param {number} id A unique integer value identifying this ユーザー.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customUserGetUserGroupRoleRetrieve(groupId: number, id: number, options?: any): AxiosPromise<UserGroupRoleResponse> {
            return localVarFp.customUserGetUserGroupRoleRetrieve(groupId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * API to return user details.  Possible ordering fields are `username`, `kanjiname`, and `id`.  Possible filtering fields are documented below. - `kanjiname`, `organization`, `hiragana_name`, `group_ids`, and `exclude_current_user`.  If the selected search pattern is user_info or no search pattern is selected search will be performed on the `kanjiname`, `hiragana_name`, and `ID` of the user.  If the selected search pattern is user_and_group_info, search will be performed on `kanjiname`, `hiragana_name`, `id` of user and `group__name`, and `group__code` of group.  For GET and PATCH API calls, pass in id `0` for the current logged in user.
         * @param {string} [excludeCurrentUser] Specify whether to exclude current user or not
         * @param {string} [groupIds] Filter by group ids. Values can be comma separated. ex: 1,2
         * @param {string} [hiraganaName] hiragana_name
         * @param {string} [isDeleted] is_deleted
         * @param {string} [kanjiname] kanjiname
         * @param {string} [nestedUsers] nested_users
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [organization] organization
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [roleType] role_type
         * @param {string} [search] A search term.
         * @param {'user_info' | 'user_and_group_info'} [searchPattern] Choose which pattern to use when searching.
         * @param {string} [username] username
         * @param {string} [usingEmployeeId] using_employee_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customUserList(excludeCurrentUser?: string, groupIds?: string, hiraganaName?: string, isDeleted?: string, kanjiname?: string, nestedUsers?: string, ordering?: string, organization?: string, page?: number, pageSize?: number, roleType?: string, search?: string, searchPattern?: 'user_info' | 'user_and_group_info', username?: string, usingEmployeeId?: string, options?: any): AxiosPromise<PaginatedCustomUserList> {
            return localVarFp.customUserList(excludeCurrentUser, groupIds, hiraganaName, isDeleted, kanjiname, nestedUsers, ordering, organization, page, pageSize, roleType, search, searchPattern, username, usingEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * API to return user details.  Possible ordering fields are `username`, `kanjiname`, and `id`.  Possible filtering fields are documented below. - `kanjiname`, `organization`, `hiragana_name`, `group_ids`, and `exclude_current_user`.  If the selected search pattern is user_info or no search pattern is selected search will be performed on the `kanjiname`, `hiragana_name`, and `ID` of the user.  If the selected search pattern is user_and_group_info, search will be performed on `kanjiname`, `hiragana_name`, `id` of user and `group__name`, and `group__code` of group.  For GET and PATCH API calls, pass in id `0` for the current logged in user.
         * @param {number} id A unique integer value identifying this ユーザー.
         * @param {string} [bio] A short description of the user, provided by the user themselves
         * @param {File} [avatar] User avatar. Response will be full URL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customUserPartialUpdate(id: number, bio?: string, avatar?: File, options?: any): AxiosPromise<CustomUser> {
            return localVarFp.customUserPartialUpdate(id, bio, avatar, options).then((request) => request(axios, basePath));
        },
        /**
         * API to return user details.  Possible ordering fields are `username`, `kanjiname`, and `id`.  Possible filtering fields are documented below. - `kanjiname`, `organization`, `hiragana_name`, `group_ids`, and `exclude_current_user`.  If the selected search pattern is user_info or no search pattern is selected search will be performed on the `kanjiname`, `hiragana_name`, and `ID` of the user.  If the selected search pattern is user_and_group_info, search will be performed on `kanjiname`, `hiragana_name`, `id` of user and `group__name`, and `group__code` of group.  For GET and PATCH API calls, pass in id `0` for the current logged in user.
         * @param {number} id A unique integer value identifying this ユーザー.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customUserRetrieve(id: number, options?: any): AxiosPromise<CustomUser> {
            return localVarFp.customUserRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomUserApi - object-oriented interface
 * @export
 * @class CustomUserApi
 * @extends {BaseAPI}
 */
export class CustomUserApi extends BaseAPI {
    /**
     * API endpoint that return what permission does the user have in a given group.
     * @param {string} group ID of the group to query
     * @param {number} id A unique integer value identifying this ユーザー.
     * @param {string} [excludeCurrentUser] Specify whether to exclude current user or not
     * @param {string} [groupIds] Filter by group ids. Values can be comma separated. ex: 1,2
     * @param {string} [hiraganaName] hiragana_name
     * @param {string} [isDeleted] is_deleted
     * @param {string} [kanjiname] kanjiname
     * @param {string} [nestedUsers] nested_users
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [organization] organization
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [roleType] role_type
     * @param {string} [search] A search term.
     * @param {'user_info' | 'user_and_group_info'} [searchPattern] Choose which pattern to use when searching.
     * @param {string} [username] username
     * @param {string} [usingEmployeeId] using_employee_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomUserApi
     */
    public customUserGetGroupPermissionsList(group: string, id: number, excludeCurrentUser?: string, groupIds?: string, hiraganaName?: string, isDeleted?: string, kanjiname?: string, nestedUsers?: string, ordering?: string, organization?: string, page?: number, pageSize?: number, roleType?: string, search?: string, searchPattern?: 'user_info' | 'user_and_group_info', username?: string, usingEmployeeId?: string, options?: AxiosRequestConfig) {
        return CustomUserApiFp(this.configuration).customUserGetGroupPermissionsList(group, id, excludeCurrentUser, groupIds, hiraganaName, isDeleted, kanjiname, nestedUsers, ordering, organization, page, pageSize, roleType, search, searchPattern, username, usingEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to return user details.  Possible ordering fields are `username`, `kanjiname`, and `id`.  Possible filtering fields are documented below. - `kanjiname`, `organization`, `hiragana_name`, `group_ids`, and `exclude_current_user`.  If the selected search pattern is user_info or no search pattern is selected search will be performed on the `kanjiname`, `hiragana_name`, and `ID` of the user.  If the selected search pattern is user_and_group_info, search will be performed on `kanjiname`, `hiragana_name`, `id` of user and `group__name`, and `group__code` of group.  For GET and PATCH API calls, pass in id `0` for the current logged in user.
     * @param {number} groupId ID of the group to query
     * @param {number} id A unique integer value identifying this ユーザー.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomUserApi
     */
    public customUserGetUserGroupRoleRetrieve(groupId: number, id: number, options?: AxiosRequestConfig) {
        return CustomUserApiFp(this.configuration).customUserGetUserGroupRoleRetrieve(groupId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to return user details.  Possible ordering fields are `username`, `kanjiname`, and `id`.  Possible filtering fields are documented below. - `kanjiname`, `organization`, `hiragana_name`, `group_ids`, and `exclude_current_user`.  If the selected search pattern is user_info or no search pattern is selected search will be performed on the `kanjiname`, `hiragana_name`, and `ID` of the user.  If the selected search pattern is user_and_group_info, search will be performed on `kanjiname`, `hiragana_name`, `id` of user and `group__name`, and `group__code` of group.  For GET and PATCH API calls, pass in id `0` for the current logged in user.
     * @param {string} [excludeCurrentUser] Specify whether to exclude current user or not
     * @param {string} [groupIds] Filter by group ids. Values can be comma separated. ex: 1,2
     * @param {string} [hiraganaName] hiragana_name
     * @param {string} [isDeleted] is_deleted
     * @param {string} [kanjiname] kanjiname
     * @param {string} [nestedUsers] nested_users
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [organization] organization
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [roleType] role_type
     * @param {string} [search] A search term.
     * @param {'user_info' | 'user_and_group_info'} [searchPattern] Choose which pattern to use when searching.
     * @param {string} [username] username
     * @param {string} [usingEmployeeId] using_employee_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomUserApi
     */
    public customUserList(excludeCurrentUser?: string, groupIds?: string, hiraganaName?: string, isDeleted?: string, kanjiname?: string, nestedUsers?: string, ordering?: string, organization?: string, page?: number, pageSize?: number, roleType?: string, search?: string, searchPattern?: 'user_info' | 'user_and_group_info', username?: string, usingEmployeeId?: string, options?: AxiosRequestConfig) {
        return CustomUserApiFp(this.configuration).customUserList(excludeCurrentUser, groupIds, hiraganaName, isDeleted, kanjiname, nestedUsers, ordering, organization, page, pageSize, roleType, search, searchPattern, username, usingEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to return user details.  Possible ordering fields are `username`, `kanjiname`, and `id`.  Possible filtering fields are documented below. - `kanjiname`, `organization`, `hiragana_name`, `group_ids`, and `exclude_current_user`.  If the selected search pattern is user_info or no search pattern is selected search will be performed on the `kanjiname`, `hiragana_name`, and `ID` of the user.  If the selected search pattern is user_and_group_info, search will be performed on `kanjiname`, `hiragana_name`, `id` of user and `group__name`, and `group__code` of group.  For GET and PATCH API calls, pass in id `0` for the current logged in user.
     * @param {number} id A unique integer value identifying this ユーザー.
     * @param {string} [bio] A short description of the user, provided by the user themselves
     * @param {File} [avatar] User avatar. Response will be full URL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomUserApi
     */
    public customUserPartialUpdate(id: number, bio?: string, avatar?: File, options?: AxiosRequestConfig) {
        return CustomUserApiFp(this.configuration).customUserPartialUpdate(id, bio, avatar, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to return user details.  Possible ordering fields are `username`, `kanjiname`, and `id`.  Possible filtering fields are documented below. - `kanjiname`, `organization`, `hiragana_name`, `group_ids`, and `exclude_current_user`.  If the selected search pattern is user_info or no search pattern is selected search will be performed on the `kanjiname`, `hiragana_name`, and `ID` of the user.  If the selected search pattern is user_and_group_info, search will be performed on `kanjiname`, `hiragana_name`, `id` of user and `group__name`, and `group__code` of group.  For GET and PATCH API calls, pass in id `0` for the current logged in user.
     * @param {number} id A unique integer value identifying this ユーザー.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomUserApi
     */
    public customUserRetrieve(id: number, options?: AxiosRequestConfig) {
        return CustomUserApiFp(this.configuration).customUserRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomUserTokenApi - axios parameter creator
 * @export
 */
export const CustomUserTokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customUserTokenList: async (ordering?: string, page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CustomUserToken/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this ユーザー.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customUserTokenRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customUserTokenRetrieve', 'id', id)
            const localVarPath = `/api/CustomUserToken/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomUserTokenApi - functional programming interface
 * @export
 */
export const CustomUserTokenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomUserTokenApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customUserTokenList(ordering?: string, page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCustomUserTokenList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customUserTokenList(ordering, page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this ユーザー.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customUserTokenRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomUserToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customUserTokenRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomUserTokenApi - factory interface
 * @export
 */
export const CustomUserTokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomUserTokenApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customUserTokenList(ordering?: string, page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<PaginatedCustomUserTokenList> {
            return localVarFp.customUserTokenList(ordering, page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this ユーザー.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customUserTokenRetrieve(id: number, options?: any): AxiosPromise<CustomUserToken> {
            return localVarFp.customUserTokenRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomUserTokenApi - object-oriented interface
 * @export
 * @class CustomUserTokenApi
 * @extends {BaseAPI}
 */
export class CustomUserTokenApi extends BaseAPI {
    /**
     * 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomUserTokenApi
     */
    public customUserTokenList(ordering?: string, page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return CustomUserTokenApiFp(this.configuration).customUserTokenList(ordering, page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this ユーザー.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomUserTokenApi
     */
    public customUserTokenRetrieve(id: number, options?: AxiosRequestConfig) {
        return CustomUserTokenApiFp(this.configuration).customUserTokenRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EmailResetApi - axios parameter creator
 * @export
 */
export const EmailResetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows to change email.
         * @param {EmailResetRequestRequest} emailResetRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailResetCreate: async (emailResetRequestRequest: EmailResetRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailResetRequestRequest' is not null or undefined
            assertParamExists('emailResetCreate', 'emailResetRequestRequest', emailResetRequestRequest)
            const localVarPath = `/api/email_reset/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailResetRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows to verify email change.
         * @param {PatchedEmailResetRequest} [patchedEmailResetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailResetVerificationPartialUpdate: async (patchedEmailResetRequest?: PatchedEmailResetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/email_reset/verification/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedEmailResetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows to verify uuid.
         * @param {PatchedEmailResetUUIDRequest} [patchedEmailResetUUIDRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailResetVerificationUuidPartialUpdate: async (patchedEmailResetUUIDRequest?: PatchedEmailResetUUIDRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/email_reset/verification_uuid/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedEmailResetUUIDRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailResetApi - functional programming interface
 * @export
 */
export const EmailResetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailResetApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows to change email.
         * @param {EmailResetRequestRequest} emailResetRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailResetCreate(emailResetRequestRequest: EmailResetRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailReset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailResetCreate(emailResetRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows to verify email change.
         * @param {PatchedEmailResetRequest} [patchedEmailResetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailResetVerificationPartialUpdate(patchedEmailResetRequest?: PatchedEmailResetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailReset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailResetVerificationPartialUpdate(patchedEmailResetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows to verify uuid.
         * @param {PatchedEmailResetUUIDRequest} [patchedEmailResetUUIDRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailResetVerificationUuidPartialUpdate(patchedEmailResetUUIDRequest?: PatchedEmailResetUUIDRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailResetUUID>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailResetVerificationUuidPartialUpdate(patchedEmailResetUUIDRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmailResetApi - factory interface
 * @export
 */
export const EmailResetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailResetApiFp(configuration)
    return {
        /**
         * API endpoint that allows to change email.
         * @param {EmailResetRequestRequest} emailResetRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailResetCreate(emailResetRequestRequest: EmailResetRequestRequest, options?: any): AxiosPromise<EmailReset> {
            return localVarFp.emailResetCreate(emailResetRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows to verify email change.
         * @param {PatchedEmailResetRequest} [patchedEmailResetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailResetVerificationPartialUpdate(patchedEmailResetRequest?: PatchedEmailResetRequest, options?: any): AxiosPromise<EmailReset> {
            return localVarFp.emailResetVerificationPartialUpdate(patchedEmailResetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows to verify uuid.
         * @param {PatchedEmailResetUUIDRequest} [patchedEmailResetUUIDRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailResetVerificationUuidPartialUpdate(patchedEmailResetUUIDRequest?: PatchedEmailResetUUIDRequest, options?: any): AxiosPromise<EmailResetUUID> {
            return localVarFp.emailResetVerificationUuidPartialUpdate(patchedEmailResetUUIDRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailResetApi - object-oriented interface
 * @export
 * @class EmailResetApi
 * @extends {BaseAPI}
 */
export class EmailResetApi extends BaseAPI {
    /**
     * API endpoint that allows to change email.
     * @param {EmailResetRequestRequest} emailResetRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailResetApi
     */
    public emailResetCreate(emailResetRequestRequest: EmailResetRequestRequest, options?: AxiosRequestConfig) {
        return EmailResetApiFp(this.configuration).emailResetCreate(emailResetRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows to verify email change.
     * @param {PatchedEmailResetRequest} [patchedEmailResetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailResetApi
     */
    public emailResetVerificationPartialUpdate(patchedEmailResetRequest?: PatchedEmailResetRequest, options?: AxiosRequestConfig) {
        return EmailResetApiFp(this.configuration).emailResetVerificationPartialUpdate(patchedEmailResetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows to verify uuid.
     * @param {PatchedEmailResetUUIDRequest} [patchedEmailResetUUIDRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailResetApi
     */
    public emailResetVerificationUuidPartialUpdate(patchedEmailResetUUIDRequest?: PatchedEmailResetUUIDRequest, options?: AxiosRequestConfig) {
        return EmailResetApiFp(this.configuration).emailResetVerificationUuidPartialUpdate(patchedEmailResetUUIDRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GroupApi - axios parameter creator
 * @export
 */
export const GroupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Viewset which allows reading of Groups. Possible ordering fields are `name`, \'code` and `id`. Possible filtering fields are documented `organization`. Searching will search the name, code.
         * @param {string} [code] code
         * @param {string} [hierarchy] hierarchy
         * @param {string} [id] id
         * @param {string} [ids] Filter by ids. Values can be comma separated. ex: 1,2
         * @param {string} [isDeleted] is_deleted
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [organization] organization
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [parentGroup] parent_group
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupList: async (code?: string, hierarchy?: string, id?: string, ids?: string, isDeleted?: string, ordering?: string, organization?: string, page?: number, pageSize?: number, parentGroup?: string, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/group/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (hierarchy !== undefined) {
                localVarQueryParameter['hierarchy'] = hierarchy;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['is_deleted'] = isDeleted;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (organization !== undefined) {
                localVarQueryParameter['organization'] = organization;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (parentGroup !== undefined) {
                localVarQueryParameter['parent_group'] = parentGroup;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Viewset which allows reading of Groups. Possible ordering fields are `name`, \'code` and `id`. Possible filtering fields are documented `organization`. Searching will search the name, code.
         * @param {number} id A unique integer value identifying this group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('groupRetrieve', 'id', id)
            const localVarPath = `/api/group/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupApi - functional programming interface
 * @export
 */
export const GroupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GroupApiAxiosParamCreator(configuration)
    return {
        /**
         * Viewset which allows reading of Groups. Possible ordering fields are `name`, \'code` and `id`. Possible filtering fields are documented `organization`. Searching will search the name, code.
         * @param {string} [code] code
         * @param {string} [hierarchy] hierarchy
         * @param {string} [id] id
         * @param {string} [ids] Filter by ids. Values can be comma separated. ex: 1,2
         * @param {string} [isDeleted] is_deleted
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [organization] organization
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [parentGroup] parent_group
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupList(code?: string, hierarchy?: string, id?: string, ids?: string, isDeleted?: string, ordering?: string, organization?: string, page?: number, pageSize?: number, parentGroup?: string, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedGroupList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupList(code, hierarchy, id, ids, isDeleted, ordering, organization, page, pageSize, parentGroup, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Viewset which allows reading of Groups. Possible ordering fields are `name`, \'code` and `id`. Possible filtering fields are documented `organization`. Searching will search the name, code.
         * @param {number} id A unique integer value identifying this group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Group>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GroupApi - factory interface
 * @export
 */
export const GroupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GroupApiFp(configuration)
    return {
        /**
         * Viewset which allows reading of Groups. Possible ordering fields are `name`, \'code` and `id`. Possible filtering fields are documented `organization`. Searching will search the name, code.
         * @param {string} [code] code
         * @param {string} [hierarchy] hierarchy
         * @param {string} [id] id
         * @param {string} [ids] Filter by ids. Values can be comma separated. ex: 1,2
         * @param {string} [isDeleted] is_deleted
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [organization] organization
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [parentGroup] parent_group
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupList(code?: string, hierarchy?: string, id?: string, ids?: string, isDeleted?: string, ordering?: string, organization?: string, page?: number, pageSize?: number, parentGroup?: string, search?: string, options?: any): AxiosPromise<PaginatedGroupList> {
            return localVarFp.groupList(code, hierarchy, id, ids, isDeleted, ordering, organization, page, pageSize, parentGroup, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Viewset which allows reading of Groups. Possible ordering fields are `name`, \'code` and `id`. Possible filtering fields are documented `organization`. Searching will search the name, code.
         * @param {number} id A unique integer value identifying this group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupRetrieve(id: number, options?: any): AxiosPromise<Group> {
            return localVarFp.groupRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GroupApi - object-oriented interface
 * @export
 * @class GroupApi
 * @extends {BaseAPI}
 */
export class GroupApi extends BaseAPI {
    /**
     * Viewset which allows reading of Groups. Possible ordering fields are `name`, \'code` and `id`. Possible filtering fields are documented `organization`. Searching will search the name, code.
     * @param {string} [code] code
     * @param {string} [hierarchy] hierarchy
     * @param {string} [id] id
     * @param {string} [ids] Filter by ids. Values can be comma separated. ex: 1,2
     * @param {string} [isDeleted] is_deleted
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [organization] organization
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [parentGroup] parent_group
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public groupList(code?: string, hierarchy?: string, id?: string, ids?: string, isDeleted?: string, ordering?: string, organization?: string, page?: number, pageSize?: number, parentGroup?: string, search?: string, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).groupList(code, hierarchy, id, ids, isDeleted, ordering, organization, page, pageSize, parentGroup, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Viewset which allows reading of Groups. Possible ordering fields are `name`, \'code` and `id`. Possible filtering fields are documented `organization`. Searching will search the name, code.
     * @param {number} id A unique integer value identifying this group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public groupRetrieve(id: number, options?: AxiosRequestConfig) {
        return GroupApiFp(this.configuration).groupRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InitialInfoApi - axios parameter creator
 * @export
 */
export const InitialInfoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows to register initial information.
         * @param {InitialInfoRequestRequest} initialInfoRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initialInfoCreate: async (initialInfoRequestRequest: InitialInfoRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'initialInfoRequestRequest' is not null or undefined
            assertParamExists('initialInfoCreate', 'initialInfoRequestRequest', initialInfoRequestRequest)
            const localVarPath = `/api/initial_info/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(initialInfoRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows to confirm initial information.
         * @param {PatchedInitialInfoUUIDRequest} [patchedInitialInfoUUIDRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initialInfoRegistrationPartialUpdate: async (patchedInitialInfoUUIDRequest?: PatchedInitialInfoUUIDRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/initial_info/registration/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedInitialInfoUUIDRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InitialInfoApi - functional programming interface
 * @export
 */
export const InitialInfoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InitialInfoApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows to register initial information.
         * @param {InitialInfoRequestRequest} initialInfoRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initialInfoCreate(initialInfoRequestRequest: InitialInfoRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InitialInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initialInfoCreate(initialInfoRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows to confirm initial information.
         * @param {PatchedInitialInfoUUIDRequest} [patchedInitialInfoUUIDRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initialInfoRegistrationPartialUpdate(patchedInitialInfoUUIDRequest?: PatchedInitialInfoUUIDRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InitialInfoUUID>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initialInfoRegistrationPartialUpdate(patchedInitialInfoUUIDRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InitialInfoApi - factory interface
 * @export
 */
export const InitialInfoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InitialInfoApiFp(configuration)
    return {
        /**
         * API endpoint that allows to register initial information.
         * @param {InitialInfoRequestRequest} initialInfoRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initialInfoCreate(initialInfoRequestRequest: InitialInfoRequestRequest, options?: any): AxiosPromise<InitialInfo> {
            return localVarFp.initialInfoCreate(initialInfoRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows to confirm initial information.
         * @param {PatchedInitialInfoUUIDRequest} [patchedInitialInfoUUIDRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initialInfoRegistrationPartialUpdate(patchedInitialInfoUUIDRequest?: PatchedInitialInfoUUIDRequest, options?: any): AxiosPromise<InitialInfoUUID> {
            return localVarFp.initialInfoRegistrationPartialUpdate(patchedInitialInfoUUIDRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InitialInfoApi - object-oriented interface
 * @export
 * @class InitialInfoApi
 * @extends {BaseAPI}
 */
export class InitialInfoApi extends BaseAPI {
    /**
     * API endpoint that allows to register initial information.
     * @param {InitialInfoRequestRequest} initialInfoRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InitialInfoApi
     */
    public initialInfoCreate(initialInfoRequestRequest: InitialInfoRequestRequest, options?: AxiosRequestConfig) {
        return InitialInfoApiFp(this.configuration).initialInfoCreate(initialInfoRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows to confirm initial information.
     * @param {PatchedInitialInfoUUIDRequest} [patchedInitialInfoUUIDRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InitialInfoApi
     */
    public initialInfoRegistrationPartialUpdate(patchedInitialInfoUUIDRequest?: PatchedInitialInfoUUIDRequest, options?: AxiosRequestConfig) {
        return InitialInfoApiFp(this.configuration).initialInfoRegistrationPartialUpdate(patchedInitialInfoUUIDRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LoginApi - axios parameter creator
 * @export
 */
export const LoginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} accessToken 
         * @param {string} refreshToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaccountBpfUserInfoCreate: async (accessToken: string, refreshToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessToken' is not null or undefined
            assertParamExists('loginBaccountBpfUserInfoCreate', 'accessToken', accessToken)
            // verify required parameter 'refreshToken' is not null or undefined
            assertParamExists('loginBaccountBpfUserInfoCreate', 'refreshToken', refreshToken)
            const localVarPath = `/api/login/baccount/bpf_user_info/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accessToken !== undefined) {
                localVarQueryParameter['access_token'] = accessToken;
            }

            if (refreshToken !== undefined) {
                localVarQueryParameter['refresh_token'] = refreshToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Call Bauth Redis Cluster Key Author: Kim Jeonghun (SystemI) 2021/08/24
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaccountCallKeyRetrieve: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/login/baccount/call_key/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Callback Function from BenefitOne Authentication Facade Author: Kim Jeonghun (SystemI) 2021/08/24
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaccountCallbackRetrieve: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/login/baccount/callback/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaccountCheckMultiContractsRetrieve: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/login/baccount/check_multi_contracts/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaccountGetBpfTokensRetrieve: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('loginBaccountGetBpfTokensRetrieve', 'key', key)
            const localVarPath = `/api/login/baccount/get_bpf_tokens/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaccountGetContractInfoRetrieve: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('loginBaccountGetContractInfoRetrieve', 'key', key)
            const localVarPath = `/api/login/baccount/get_contract_info/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Bauth Info Author: Kim Jeonghun (SystemI) 2021/08/24
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaccountGetInfoRetrieve: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('loginBaccountGetInfoRetrieve', 'key', key)
            const localVarPath = `/api/login/baccount/get_info/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Bauth Redis Cluster Key Author: Kim Jeonghun (SystemI) 2021/08/24
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaccountGetKeyRetrieve: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/login/baccount/get_key/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Redirect to Benefit One Authentication Facade Author: Kim Jeonghun (SystemI) 2021/08/24
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaccountRetrieve: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/login/baccount/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoginApi - functional programming interface
 * @export
 */
export const LoginApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoginApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} accessToken 
         * @param {string} refreshToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginBaccountBpfUserInfoCreate(accessToken: string, refreshToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BPFUserInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginBaccountBpfUserInfoCreate(accessToken, refreshToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Call Bauth Redis Cluster Key Author: Kim Jeonghun (SystemI) 2021/08/24
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginBaccountCallKeyRetrieve(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginBaccountCallKeyRetrieve(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Callback Function from BenefitOne Authentication Facade Author: Kim Jeonghun (SystemI) 2021/08/24
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginBaccountCallbackRetrieve(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginBaccountCallbackRetrieve(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginBaccountCheckMultiContractsRetrieve(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginBaccountCheckMultiContractsRetrieve(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginBaccountGetBpfTokensRetrieve(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginBaccountGetBpfTokensRetrieve(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginBaccountGetContractInfoRetrieve(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginBaccountGetContractInfoRetrieve(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get Bauth Info Author: Kim Jeonghun (SystemI) 2021/08/24
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginBaccountGetInfoRetrieve(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaccountInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginBaccountGetInfoRetrieve(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get Bauth Redis Cluster Key Author: Kim Jeonghun (SystemI) 2021/08/24
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginBaccountGetKeyRetrieve(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginBaccountGetKeyRetrieve(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Redirect to Benefit One Authentication Facade Author: Kim Jeonghun (SystemI) 2021/08/24
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginBaccountRetrieve(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginBaccountRetrieve(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LoginApi - factory interface
 * @export
 */
export const LoginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoginApiFp(configuration)
    return {
        /**
         * 
         * @param {string} accessToken 
         * @param {string} refreshToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaccountBpfUserInfoCreate(accessToken: string, refreshToken: string, options?: any): AxiosPromise<BPFUserInfoResponse> {
            return localVarFp.loginBaccountBpfUserInfoCreate(accessToken, refreshToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Call Bauth Redis Cluster Key Author: Kim Jeonghun (SystemI) 2021/08/24
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaccountCallKeyRetrieve(options?: any): AxiosPromise<void> {
            return localVarFp.loginBaccountCallKeyRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * Callback Function from BenefitOne Authentication Facade Author: Kim Jeonghun (SystemI) 2021/08/24
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaccountCallbackRetrieve(options?: any): AxiosPromise<void> {
            return localVarFp.loginBaccountCallbackRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaccountCheckMultiContractsRetrieve(options?: any): AxiosPromise<void> {
            return localVarFp.loginBaccountCheckMultiContractsRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaccountGetBpfTokensRetrieve(key: string, options?: any): AxiosPromise<void> {
            return localVarFp.loginBaccountGetBpfTokensRetrieve(key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaccountGetContractInfoRetrieve(key: string, options?: any): AxiosPromise<void> {
            return localVarFp.loginBaccountGetContractInfoRetrieve(key, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Bauth Info Author: Kim Jeonghun (SystemI) 2021/08/24
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaccountGetInfoRetrieve(key: string, options?: any): AxiosPromise<BaccountInfo> {
            return localVarFp.loginBaccountGetInfoRetrieve(key, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Bauth Redis Cluster Key Author: Kim Jeonghun (SystemI) 2021/08/24
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaccountGetKeyRetrieve(options?: any): AxiosPromise<void> {
            return localVarFp.loginBaccountGetKeyRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * Redirect to Benefit One Authentication Facade Author: Kim Jeonghun (SystemI) 2021/08/24
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaccountRetrieve(options?: any): AxiosPromise<void> {
            return localVarFp.loginBaccountRetrieve(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoginApi - object-oriented interface
 * @export
 * @class LoginApi
 * @extends {BaseAPI}
 */
export class LoginApi extends BaseAPI {
    /**
     * 
     * @param {string} accessToken 
     * @param {string} refreshToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public loginBaccountBpfUserInfoCreate(accessToken: string, refreshToken: string, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).loginBaccountBpfUserInfoCreate(accessToken, refreshToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Call Bauth Redis Cluster Key Author: Kim Jeonghun (SystemI) 2021/08/24
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public loginBaccountCallKeyRetrieve(options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).loginBaccountCallKeyRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Callback Function from BenefitOne Authentication Facade Author: Kim Jeonghun (SystemI) 2021/08/24
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public loginBaccountCallbackRetrieve(options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).loginBaccountCallbackRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public loginBaccountCheckMultiContractsRetrieve(options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).loginBaccountCheckMultiContractsRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public loginBaccountGetBpfTokensRetrieve(key: string, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).loginBaccountGetBpfTokensRetrieve(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public loginBaccountGetContractInfoRetrieve(key: string, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).loginBaccountGetContractInfoRetrieve(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Bauth Info Author: Kim Jeonghun (SystemI) 2021/08/24
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public loginBaccountGetInfoRetrieve(key: string, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).loginBaccountGetInfoRetrieve(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Bauth Redis Cluster Key Author: Kim Jeonghun (SystemI) 2021/08/24
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public loginBaccountGetKeyRetrieve(options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).loginBaccountGetKeyRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Redirect to Benefit One Authentication Facade Author: Kim Jeonghun (SystemI) 2021/08/24
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public loginBaccountRetrieve(options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).loginBaccountRetrieve(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MaintenanceErrorSettingApi - axios parameter creator
 * @export
 */
export const MaintenanceErrorSettingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows maintenance error settings.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maintenanceErrorSettingList: async (page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/maintenance_error_setting/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows maintenance error settings.
         * @param {number} id A unique integer value identifying this maintenance error setting.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maintenanceErrorSettingRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('maintenanceErrorSettingRetrieve', 'id', id)
            const localVarPath = `/api/maintenance_error_setting/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MaintenanceErrorSettingApi - functional programming interface
 * @export
 */
export const MaintenanceErrorSettingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MaintenanceErrorSettingApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows maintenance error settings.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async maintenanceErrorSettingList(page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedMaintenanceErrorSettingList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.maintenanceErrorSettingList(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows maintenance error settings.
         * @param {number} id A unique integer value identifying this maintenance error setting.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async maintenanceErrorSettingRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaintenanceErrorSetting>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.maintenanceErrorSettingRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MaintenanceErrorSettingApi - factory interface
 * @export
 */
export const MaintenanceErrorSettingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MaintenanceErrorSettingApiFp(configuration)
    return {
        /**
         * API endpoint that allows maintenance error settings.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maintenanceErrorSettingList(page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedMaintenanceErrorSettingList> {
            return localVarFp.maintenanceErrorSettingList(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows maintenance error settings.
         * @param {number} id A unique integer value identifying this maintenance error setting.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        maintenanceErrorSettingRetrieve(id: number, options?: any): AxiosPromise<MaintenanceErrorSetting> {
            return localVarFp.maintenanceErrorSettingRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MaintenanceErrorSettingApi - object-oriented interface
 * @export
 * @class MaintenanceErrorSettingApi
 * @extends {BaseAPI}
 */
export class MaintenanceErrorSettingApi extends BaseAPI {
    /**
     * API endpoint that allows maintenance error settings.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceErrorSettingApi
     */
    public maintenanceErrorSettingList(page?: number, pageSize?: number, options?: AxiosRequestConfig) {
        return MaintenanceErrorSettingApiFp(this.configuration).maintenanceErrorSettingList(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows maintenance error settings.
     * @param {number} id A unique integer value identifying this maintenance error setting.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceErrorSettingApi
     */
    public maintenanceErrorSettingRetrieve(id: number, options?: AxiosRequestConfig) {
        return MaintenanceErrorSettingApiFp(this.configuration).maintenanceErrorSettingRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationApi - axios parameter creator
 * @export
 */
export const OrganizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows anonymous reading of organization names.
         * @param {OrganizationRequest} organizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationCreate: async (organizationRequest: OrganizationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationRequest' is not null or undefined
            assertParamExists('organizationCreate', 'organizationRequest', organizationRequest)
            const localVarPath = `/api/organization/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows anonymous reading of organization names.
         * @param {number} id A unique integer value identifying this organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationDestroy: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationDestroy', 'id', id)
            const localVarPath = `/api/organization/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows anonymous reading of organization names.
         * @param {string} [companyCode] company_code
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [slug] slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationList: async (companyCode?: string, ordering?: string, page?: number, pageSize?: number, search?: string, slug?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organization/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyCode !== undefined) {
                localVarQueryParameter['company_code'] = companyCode;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows anonymous reading of organization names.
         * @param {number} id A unique integer value identifying this organization.
         * @param {PatchedOrganizationRequest} [patchedOrganizationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPartialUpdate: async (id: number, patchedOrganizationRequest?: PatchedOrganizationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationPartialUpdate', 'id', id)
            const localVarPath = `/api/organization/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows anonymous reading of organization names.
         * @param {number} id A unique integer value identifying this organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationRetrieve', 'id', id)
            const localVarPath = `/api/organization/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows anonymous reading of organization names.
         * @param {number} id A unique integer value identifying this organization.
         * @param {OrganizationRequest} organizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationUpdate: async (id: number, organizationRequest: OrganizationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationUpdate', 'id', id)
            // verify required parameter 'organizationRequest' is not null or undefined
            assertParamExists('organizationUpdate', 'organizationRequest', organizationRequest)
            const localVarPath = `/api/organization/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationApi - functional programming interface
 * @export
 */
export const OrganizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows anonymous reading of organization names.
         * @param {OrganizationRequest} organizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationCreate(organizationRequest: OrganizationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationCreate(organizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows anonymous reading of organization names.
         * @param {number} id A unique integer value identifying this organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationDestroy(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationDestroy(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows anonymous reading of organization names.
         * @param {string} [companyCode] company_code
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [slug] slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationList(companyCode?: string, ordering?: string, page?: number, pageSize?: number, search?: string, slug?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOrganizationList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationList(companyCode, ordering, page, pageSize, search, slug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows anonymous reading of organization names.
         * @param {number} id A unique integer value identifying this organization.
         * @param {PatchedOrganizationRequest} [patchedOrganizationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationPartialUpdate(id: number, patchedOrganizationRequest?: PatchedOrganizationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationPartialUpdate(id, patchedOrganizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows anonymous reading of organization names.
         * @param {number} id A unique integer value identifying this organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows anonymous reading of organization names.
         * @param {number} id A unique integer value identifying this organization.
         * @param {OrganizationRequest} organizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationUpdate(id: number, organizationRequest: OrganizationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationUpdate(id, organizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationApi - factory interface
 * @export
 */
export const OrganizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationApiFp(configuration)
    return {
        /**
         * API endpoint that allows anonymous reading of organization names.
         * @param {OrganizationRequest} organizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationCreate(organizationRequest: OrganizationRequest, options?: any): AxiosPromise<Organization> {
            return localVarFp.organizationCreate(organizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows anonymous reading of organization names.
         * @param {number} id A unique integer value identifying this organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationDestroy(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.organizationDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows anonymous reading of organization names.
         * @param {string} [companyCode] company_code
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [slug] slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationList(companyCode?: string, ordering?: string, page?: number, pageSize?: number, search?: string, slug?: string, options?: any): AxiosPromise<PaginatedOrganizationList> {
            return localVarFp.organizationList(companyCode, ordering, page, pageSize, search, slug, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows anonymous reading of organization names.
         * @param {number} id A unique integer value identifying this organization.
         * @param {PatchedOrganizationRequest} [patchedOrganizationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPartialUpdate(id: number, patchedOrganizationRequest?: PatchedOrganizationRequest, options?: any): AxiosPromise<Organization> {
            return localVarFp.organizationPartialUpdate(id, patchedOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows anonymous reading of organization names.
         * @param {number} id A unique integer value identifying this organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationRetrieve(id: number, options?: any): AxiosPromise<Organization> {
            return localVarFp.organizationRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows anonymous reading of organization names.
         * @param {number} id A unique integer value identifying this organization.
         * @param {OrganizationRequest} organizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationUpdate(id: number, organizationRequest: OrganizationRequest, options?: any): AxiosPromise<Organization> {
            return localVarFp.organizationUpdate(id, organizationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationApi - object-oriented interface
 * @export
 * @class OrganizationApi
 * @extends {BaseAPI}
 */
export class OrganizationApi extends BaseAPI {
    /**
     * API endpoint that allows anonymous reading of organization names.
     * @param {OrganizationRequest} organizationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationCreate(organizationRequest: OrganizationRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationCreate(organizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows anonymous reading of organization names.
     * @param {number} id A unique integer value identifying this organization.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationDestroy(id: number, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows anonymous reading of organization names.
     * @param {string} [companyCode] company_code
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [slug] slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationList(companyCode?: string, ordering?: string, page?: number, pageSize?: number, search?: string, slug?: string, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationList(companyCode, ordering, page, pageSize, search, slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows anonymous reading of organization names.
     * @param {number} id A unique integer value identifying this organization.
     * @param {PatchedOrganizationRequest} [patchedOrganizationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationPartialUpdate(id: number, patchedOrganizationRequest?: PatchedOrganizationRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationPartialUpdate(id, patchedOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows anonymous reading of organization names.
     * @param {number} id A unique integer value identifying this organization.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationRetrieve(id: number, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows anonymous reading of organization names.
     * @param {number} id A unique integer value identifying this organization.
     * @param {OrganizationRequest} organizationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public organizationUpdate(id: number, organizationRequest: OrganizationRequest, options?: AxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).organizationUpdate(id, organizationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationPaymentSettingApi - axios parameter creator
 * @export
 */
export const OrganizationPaymentSettingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows user organization payment setting.
         * @param {OrganizationPaymentSettingRequest} organizationPaymentSettingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPaymentSettingCreate: async (organizationPaymentSettingRequest: OrganizationPaymentSettingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPaymentSettingRequest' is not null or undefined
            assertParamExists('organizationPaymentSettingCreate', 'organizationPaymentSettingRequest', organizationPaymentSettingRequest)
            const localVarPath = `/api/organization_payment_setting/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationPaymentSettingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows user organization payment setting.
         * @param {number} id A unique integer value identifying this organization payment setting.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPaymentSettingDestroy: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationPaymentSettingDestroy', 'id', id)
            const localVarPath = `/api/organization_payment_setting/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows user organization payment setting.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [organization] organization
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPaymentSettingList: async (ordering?: string, organization?: string, page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organization_payment_setting/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (organization !== undefined) {
                localVarQueryParameter['organization'] = organization;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows user organization payment setting.
         * @param {number} id A unique integer value identifying this organization payment setting.
         * @param {PatchedOrganizationPaymentSettingRequest} [patchedOrganizationPaymentSettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPaymentSettingPartialUpdate: async (id: number, patchedOrganizationPaymentSettingRequest?: PatchedOrganizationPaymentSettingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationPaymentSettingPartialUpdate', 'id', id)
            const localVarPath = `/api/organization_payment_setting/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedOrganizationPaymentSettingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows user organization payment setting.
         * @param {number} id A unique integer value identifying this organization payment setting.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPaymentSettingRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationPaymentSettingRetrieve', 'id', id)
            const localVarPath = `/api/organization_payment_setting/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows user organization payment setting.
         * @param {number} id A unique integer value identifying this organization payment setting.
         * @param {OrganizationPaymentSettingRequest} organizationPaymentSettingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPaymentSettingUpdate: async (id: number, organizationPaymentSettingRequest: OrganizationPaymentSettingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationPaymentSettingUpdate', 'id', id)
            // verify required parameter 'organizationPaymentSettingRequest' is not null or undefined
            assertParamExists('organizationPaymentSettingUpdate', 'organizationPaymentSettingRequest', organizationPaymentSettingRequest)
            const localVarPath = `/api/organization_payment_setting/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationPaymentSettingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationPaymentSettingApi - functional programming interface
 * @export
 */
export const OrganizationPaymentSettingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationPaymentSettingApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows user organization payment setting.
         * @param {OrganizationPaymentSettingRequest} organizationPaymentSettingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationPaymentSettingCreate(organizationPaymentSettingRequest: OrganizationPaymentSettingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationPaymentSetting>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationPaymentSettingCreate(organizationPaymentSettingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows user organization payment setting.
         * @param {number} id A unique integer value identifying this organization payment setting.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationPaymentSettingDestroy(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationPaymentSettingDestroy(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows user organization payment setting.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [organization] organization
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationPaymentSettingList(ordering?: string, organization?: string, page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedOrganizationPaymentSettingList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationPaymentSettingList(ordering, organization, page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows user organization payment setting.
         * @param {number} id A unique integer value identifying this organization payment setting.
         * @param {PatchedOrganizationPaymentSettingRequest} [patchedOrganizationPaymentSettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationPaymentSettingPartialUpdate(id: number, patchedOrganizationPaymentSettingRequest?: PatchedOrganizationPaymentSettingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationPaymentSetting>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationPaymentSettingPartialUpdate(id, patchedOrganizationPaymentSettingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows user organization payment setting.
         * @param {number} id A unique integer value identifying this organization payment setting.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationPaymentSettingRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationPaymentSetting>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationPaymentSettingRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows user organization payment setting.
         * @param {number} id A unique integer value identifying this organization payment setting.
         * @param {OrganizationPaymentSettingRequest} organizationPaymentSettingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationPaymentSettingUpdate(id: number, organizationPaymentSettingRequest: OrganizationPaymentSettingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationPaymentSetting>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationPaymentSettingUpdate(id, organizationPaymentSettingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationPaymentSettingApi - factory interface
 * @export
 */
export const OrganizationPaymentSettingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationPaymentSettingApiFp(configuration)
    return {
        /**
         * API endpoint that allows user organization payment setting.
         * @param {OrganizationPaymentSettingRequest} organizationPaymentSettingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPaymentSettingCreate(organizationPaymentSettingRequest: OrganizationPaymentSettingRequest, options?: any): AxiosPromise<OrganizationPaymentSetting> {
            return localVarFp.organizationPaymentSettingCreate(organizationPaymentSettingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows user organization payment setting.
         * @param {number} id A unique integer value identifying this organization payment setting.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPaymentSettingDestroy(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.organizationPaymentSettingDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows user organization payment setting.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [organization] organization
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPaymentSettingList(ordering?: string, organization?: string, page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<PaginatedOrganizationPaymentSettingList> {
            return localVarFp.organizationPaymentSettingList(ordering, organization, page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows user organization payment setting.
         * @param {number} id A unique integer value identifying this organization payment setting.
         * @param {PatchedOrganizationPaymentSettingRequest} [patchedOrganizationPaymentSettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPaymentSettingPartialUpdate(id: number, patchedOrganizationPaymentSettingRequest?: PatchedOrganizationPaymentSettingRequest, options?: any): AxiosPromise<OrganizationPaymentSetting> {
            return localVarFp.organizationPaymentSettingPartialUpdate(id, patchedOrganizationPaymentSettingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows user organization payment setting.
         * @param {number} id A unique integer value identifying this organization payment setting.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPaymentSettingRetrieve(id: number, options?: any): AxiosPromise<OrganizationPaymentSetting> {
            return localVarFp.organizationPaymentSettingRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows user organization payment setting.
         * @param {number} id A unique integer value identifying this organization payment setting.
         * @param {OrganizationPaymentSettingRequest} organizationPaymentSettingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPaymentSettingUpdate(id: number, organizationPaymentSettingRequest: OrganizationPaymentSettingRequest, options?: any): AxiosPromise<OrganizationPaymentSetting> {
            return localVarFp.organizationPaymentSettingUpdate(id, organizationPaymentSettingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationPaymentSettingApi - object-oriented interface
 * @export
 * @class OrganizationPaymentSettingApi
 * @extends {BaseAPI}
 */
export class OrganizationPaymentSettingApi extends BaseAPI {
    /**
     * API endpoint that allows user organization payment setting.
     * @param {OrganizationPaymentSettingRequest} organizationPaymentSettingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationPaymentSettingApi
     */
    public organizationPaymentSettingCreate(organizationPaymentSettingRequest: OrganizationPaymentSettingRequest, options?: AxiosRequestConfig) {
        return OrganizationPaymentSettingApiFp(this.configuration).organizationPaymentSettingCreate(organizationPaymentSettingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows user organization payment setting.
     * @param {number} id A unique integer value identifying this organization payment setting.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationPaymentSettingApi
     */
    public organizationPaymentSettingDestroy(id: number, options?: AxiosRequestConfig) {
        return OrganizationPaymentSettingApiFp(this.configuration).organizationPaymentSettingDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows user organization payment setting.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [organization] organization
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationPaymentSettingApi
     */
    public organizationPaymentSettingList(ordering?: string, organization?: string, page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return OrganizationPaymentSettingApiFp(this.configuration).organizationPaymentSettingList(ordering, organization, page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows user organization payment setting.
     * @param {number} id A unique integer value identifying this organization payment setting.
     * @param {PatchedOrganizationPaymentSettingRequest} [patchedOrganizationPaymentSettingRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationPaymentSettingApi
     */
    public organizationPaymentSettingPartialUpdate(id: number, patchedOrganizationPaymentSettingRequest?: PatchedOrganizationPaymentSettingRequest, options?: AxiosRequestConfig) {
        return OrganizationPaymentSettingApiFp(this.configuration).organizationPaymentSettingPartialUpdate(id, patchedOrganizationPaymentSettingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows user organization payment setting.
     * @param {number} id A unique integer value identifying this organization payment setting.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationPaymentSettingApi
     */
    public organizationPaymentSettingRetrieve(id: number, options?: AxiosRequestConfig) {
        return OrganizationPaymentSettingApiFp(this.configuration).organizationPaymentSettingRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows user organization payment setting.
     * @param {number} id A unique integer value identifying this organization payment setting.
     * @param {OrganizationPaymentSettingRequest} organizationPaymentSettingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationPaymentSettingApi
     */
    public organizationPaymentSettingUpdate(id: number, organizationPaymentSettingRequest: OrganizationPaymentSettingRequest, options?: AxiosRequestConfig) {
        return OrganizationPaymentSettingApiFp(this.configuration).organizationPaymentSettingUpdate(id, organizationPaymentSettingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PasswordReminderApi - axios parameter creator
 * @export
 */
export const PasswordReminderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows password reminder
         * @param {PasswordReminderRequest} passwordReminderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordReminderCreate: async (passwordReminderRequest: PasswordReminderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordReminderRequest' is not null or undefined
            assertParamExists('passwordReminderCreate', 'passwordReminderRequest', passwordReminderRequest)
            const localVarPath = `/api/password_reminder/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordReminderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows password reminder
         * @param {number} id A unique integer value identifying this password reminder.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordReminderDestroy: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('passwordReminderDestroy', 'id', id)
            const localVarPath = `/api/password_reminder/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows password reminder
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordReminderList: async (ordering?: string, page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/password_reminder/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows password reminder
         * @param {number} id A unique integer value identifying this password reminder.
         * @param {PatchedPasswordReminderRequest} [patchedPasswordReminderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordReminderPartialUpdate: async (id: number, patchedPasswordReminderRequest?: PatchedPasswordReminderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('passwordReminderPartialUpdate', 'id', id)
            const localVarPath = `/api/password_reminder/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedPasswordReminderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows password reminder
         * @param {number} id A unique integer value identifying this password reminder.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordReminderRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('passwordReminderRetrieve', 'id', id)
            const localVarPath = `/api/password_reminder/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows password reminder
         * @param {number} id A unique integer value identifying this password reminder.
         * @param {PasswordReminderRequest} passwordReminderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordReminderUpdate: async (id: number, passwordReminderRequest: PasswordReminderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('passwordReminderUpdate', 'id', id)
            // verify required parameter 'passwordReminderRequest' is not null or undefined
            assertParamExists('passwordReminderUpdate', 'passwordReminderRequest', passwordReminderRequest)
            const localVarPath = `/api/password_reminder/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordReminderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PasswordReminderApi - functional programming interface
 * @export
 */
export const PasswordReminderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PasswordReminderApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows password reminder
         * @param {PasswordReminderRequest} passwordReminderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordReminderCreate(passwordReminderRequest: PasswordReminderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordReminder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.passwordReminderCreate(passwordReminderRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows password reminder
         * @param {number} id A unique integer value identifying this password reminder.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordReminderDestroy(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.passwordReminderDestroy(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows password reminder
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordReminderList(ordering?: string, page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPasswordReminderList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.passwordReminderList(ordering, page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows password reminder
         * @param {number} id A unique integer value identifying this password reminder.
         * @param {PatchedPasswordReminderRequest} [patchedPasswordReminderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordReminderPartialUpdate(id: number, patchedPasswordReminderRequest?: PatchedPasswordReminderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordReminder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.passwordReminderPartialUpdate(id, patchedPasswordReminderRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows password reminder
         * @param {number} id A unique integer value identifying this password reminder.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordReminderRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordReminder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.passwordReminderRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows password reminder
         * @param {number} id A unique integer value identifying this password reminder.
         * @param {PasswordReminderRequest} passwordReminderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordReminderUpdate(id: number, passwordReminderRequest: PasswordReminderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordReminder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.passwordReminderUpdate(id, passwordReminderRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PasswordReminderApi - factory interface
 * @export
 */
export const PasswordReminderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PasswordReminderApiFp(configuration)
    return {
        /**
         * API endpoint that allows password reminder
         * @param {PasswordReminderRequest} passwordReminderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordReminderCreate(passwordReminderRequest: PasswordReminderRequest, options?: any): AxiosPromise<PasswordReminder> {
            return localVarFp.passwordReminderCreate(passwordReminderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows password reminder
         * @param {number} id A unique integer value identifying this password reminder.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordReminderDestroy(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.passwordReminderDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows password reminder
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordReminderList(ordering?: string, page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<PaginatedPasswordReminderList> {
            return localVarFp.passwordReminderList(ordering, page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows password reminder
         * @param {number} id A unique integer value identifying this password reminder.
         * @param {PatchedPasswordReminderRequest} [patchedPasswordReminderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordReminderPartialUpdate(id: number, patchedPasswordReminderRequest?: PatchedPasswordReminderRequest, options?: any): AxiosPromise<PasswordReminder> {
            return localVarFp.passwordReminderPartialUpdate(id, patchedPasswordReminderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows password reminder
         * @param {number} id A unique integer value identifying this password reminder.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordReminderRetrieve(id: number, options?: any): AxiosPromise<PasswordReminder> {
            return localVarFp.passwordReminderRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows password reminder
         * @param {number} id A unique integer value identifying this password reminder.
         * @param {PasswordReminderRequest} passwordReminderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordReminderUpdate(id: number, passwordReminderRequest: PasswordReminderRequest, options?: any): AxiosPromise<PasswordReminder> {
            return localVarFp.passwordReminderUpdate(id, passwordReminderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PasswordReminderApi - object-oriented interface
 * @export
 * @class PasswordReminderApi
 * @extends {BaseAPI}
 */
export class PasswordReminderApi extends BaseAPI {
    /**
     * API endpoint that allows password reminder
     * @param {PasswordReminderRequest} passwordReminderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordReminderApi
     */
    public passwordReminderCreate(passwordReminderRequest: PasswordReminderRequest, options?: AxiosRequestConfig) {
        return PasswordReminderApiFp(this.configuration).passwordReminderCreate(passwordReminderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows password reminder
     * @param {number} id A unique integer value identifying this password reminder.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordReminderApi
     */
    public passwordReminderDestroy(id: number, options?: AxiosRequestConfig) {
        return PasswordReminderApiFp(this.configuration).passwordReminderDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows password reminder
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordReminderApi
     */
    public passwordReminderList(ordering?: string, page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return PasswordReminderApiFp(this.configuration).passwordReminderList(ordering, page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows password reminder
     * @param {number} id A unique integer value identifying this password reminder.
     * @param {PatchedPasswordReminderRequest} [patchedPasswordReminderRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordReminderApi
     */
    public passwordReminderPartialUpdate(id: number, patchedPasswordReminderRequest?: PatchedPasswordReminderRequest, options?: AxiosRequestConfig) {
        return PasswordReminderApiFp(this.configuration).passwordReminderPartialUpdate(id, patchedPasswordReminderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows password reminder
     * @param {number} id A unique integer value identifying this password reminder.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordReminderApi
     */
    public passwordReminderRetrieve(id: number, options?: AxiosRequestConfig) {
        return PasswordReminderApiFp(this.configuration).passwordReminderRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows password reminder
     * @param {number} id A unique integer value identifying this password reminder.
     * @param {PasswordReminderRequest} passwordReminderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordReminderApi
     */
    public passwordReminderUpdate(id: number, passwordReminderRequest: PasswordReminderRequest, options?: AxiosRequestConfig) {
        return PasswordReminderApiFp(this.configuration).passwordReminderUpdate(id, passwordReminderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PasswordReminderQuestionApi - axios parameter creator
 * @export
 */
export const PasswordReminderQuestionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows password reminder questions.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordReminderQuestionList: async (ordering?: string, page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/password_reminder_question/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows password reminder questions.
         * @param {number} id A unique integer value identifying this password reminder questions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordReminderQuestionRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('passwordReminderQuestionRetrieve', 'id', id)
            const localVarPath = `/api/password_reminder_question/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PasswordReminderQuestionApi - functional programming interface
 * @export
 */
export const PasswordReminderQuestionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PasswordReminderQuestionApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows password reminder questions.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordReminderQuestionList(ordering?: string, page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPasswordReminderQuestionsList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.passwordReminderQuestionList(ordering, page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows password reminder questions.
         * @param {number} id A unique integer value identifying this password reminder questions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordReminderQuestionRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordReminderQuestions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.passwordReminderQuestionRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PasswordReminderQuestionApi - factory interface
 * @export
 */
export const PasswordReminderQuestionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PasswordReminderQuestionApiFp(configuration)
    return {
        /**
         * API endpoint that allows password reminder questions.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordReminderQuestionList(ordering?: string, page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<PaginatedPasswordReminderQuestionsList> {
            return localVarFp.passwordReminderQuestionList(ordering, page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows password reminder questions.
         * @param {number} id A unique integer value identifying this password reminder questions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordReminderQuestionRetrieve(id: number, options?: any): AxiosPromise<PasswordReminderQuestions> {
            return localVarFp.passwordReminderQuestionRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PasswordReminderQuestionApi - object-oriented interface
 * @export
 * @class PasswordReminderQuestionApi
 * @extends {BaseAPI}
 */
export class PasswordReminderQuestionApi extends BaseAPI {
    /**
     * API endpoint that allows password reminder questions.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordReminderQuestionApi
     */
    public passwordReminderQuestionList(ordering?: string, page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return PasswordReminderQuestionApiFp(this.configuration).passwordReminderQuestionList(ordering, page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows password reminder questions.
     * @param {number} id A unique integer value identifying this password reminder questions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordReminderQuestionApi
     */
    public passwordReminderQuestionRetrieve(id: number, options?: AxiosRequestConfig) {
        return PasswordReminderQuestionApiFp(this.configuration).passwordReminderQuestionRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RoleApi - axios parameter creator
 * @export
 */
export const RoleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ViewSet which allow reading of Roles.  - Possible ordering fields are `name` and `id`. - Possible filtering fields are `name`, `organization`, and `role_type`. - Searching will search the `name`, `organization`.
         * @param {string} [name] name
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [organization] organization
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {'0' | '1' | '2' | '3' | '4' | '5'} [roleType] role_type
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleList: async (name?: string, ordering?: string, organization?: string, page?: number, pageSize?: number, roleType?: '0' | '1' | '2' | '3' | '4' | '5', search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/role/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (organization !== undefined) {
                localVarQueryParameter['organization'] = organization;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (roleType !== undefined) {
                localVarQueryParameter['role_type'] = roleType;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet which allow reading of Roles.  - Possible ordering fields are `name` and `id`. - Possible filtering fields are `name`, `organization`, and `role_type`. - Searching will search the `name`, `organization`.
         * @param {number} id A unique integer value identifying this role.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('roleRetrieve', 'id', id)
            const localVarPath = `/api/role/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoleApi - functional programming interface
 * @export
 */
export const RoleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoleApiAxiosParamCreator(configuration)
    return {
        /**
         * ViewSet which allow reading of Roles.  - Possible ordering fields are `name` and `id`. - Possible filtering fields are `name`, `organization`, and `role_type`. - Searching will search the `name`, `organization`.
         * @param {string} [name] name
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [organization] organization
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {'0' | '1' | '2' | '3' | '4' | '5'} [roleType] role_type
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roleList(name?: string, ordering?: string, organization?: string, page?: number, pageSize?: number, roleType?: '0' | '1' | '2' | '3' | '4' | '5', search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedRoleList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roleList(name, ordering, organization, page, pageSize, roleType, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ViewSet which allow reading of Roles.  - Possible ordering fields are `name` and `id`. - Possible filtering fields are `name`, `organization`, and `role_type`. - Searching will search the `name`, `organization`.
         * @param {number} id A unique integer value identifying this role.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roleRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Role>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roleRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RoleApi - factory interface
 * @export
 */
export const RoleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoleApiFp(configuration)
    return {
        /**
         * ViewSet which allow reading of Roles.  - Possible ordering fields are `name` and `id`. - Possible filtering fields are `name`, `organization`, and `role_type`. - Searching will search the `name`, `organization`.
         * @param {string} [name] name
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [organization] organization
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {'0' | '1' | '2' | '3' | '4' | '5'} [roleType] role_type
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleList(name?: string, ordering?: string, organization?: string, page?: number, pageSize?: number, roleType?: '0' | '1' | '2' | '3' | '4' | '5', search?: string, options?: any): AxiosPromise<PaginatedRoleList> {
            return localVarFp.roleList(name, ordering, organization, page, pageSize, roleType, search, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet which allow reading of Roles.  - Possible ordering fields are `name` and `id`. - Possible filtering fields are `name`, `organization`, and `role_type`. - Searching will search the `name`, `organization`.
         * @param {number} id A unique integer value identifying this role.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleRetrieve(id: number, options?: any): AxiosPromise<Role> {
            return localVarFp.roleRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoleApi - object-oriented interface
 * @export
 * @class RoleApi
 * @extends {BaseAPI}
 */
export class RoleApi extends BaseAPI {
    /**
     * ViewSet which allow reading of Roles.  - Possible ordering fields are `name` and `id`. - Possible filtering fields are `name`, `organization`, and `role_type`. - Searching will search the `name`, `organization`.
     * @param {string} [name] name
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [organization] organization
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {'0' | '1' | '2' | '3' | '4' | '5'} [roleType] role_type
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public roleList(name?: string, ordering?: string, organization?: string, page?: number, pageSize?: number, roleType?: '0' | '1' | '2' | '3' | '4' | '5', search?: string, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).roleList(name, ordering, organization, page, pageSize, roleType, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet which allow reading of Roles.  - Possible ordering fields are `name` and `id`. - Possible filtering fields are `name`, `organization`, and `role_type`. - Searching will search the `name`, `organization`.
     * @param {number} id A unique integer value identifying this role.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public roleRetrieve(id: number, options?: AxiosRequestConfig) {
        return RoleApiFp(this.configuration).roleRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RolePermissionApi - axios parameter creator
 * @export
 */
export const RolePermissionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Viewset which allowed reading of Role-Permission combination.  - Possible ordering fields `id`. - Possible filtering fields are `role`, `read`, `create`, `update`, `delete`, and `group_id`. - Searching will be performed on `role__name`.
         * @param {string} [groupId] Filter permissions by users role on particular group.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [permission] Filter by permission. Values can be comma separated. ex: 1,2
         * @param {string} [role] role
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolePermissionList: async (groupId?: string, ordering?: string, page?: number, pageSize?: number, permission?: string, role?: string, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/role_permission/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Viewset which allowed reading of Role-Permission combination.  - Possible ordering fields `id`. - Possible filtering fields are `role`, `read`, `create`, `update`, `delete`, and `group_id`. - Searching will be performed on `role__name`.
         * @param {number} id A unique integer value identifying this role permission.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolePermissionRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rolePermissionRetrieve', 'id', id)
            const localVarPath = `/api/role_permission/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RolePermissionApi - functional programming interface
 * @export
 */
export const RolePermissionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RolePermissionApiAxiosParamCreator(configuration)
    return {
        /**
         * Viewset which allowed reading of Role-Permission combination.  - Possible ordering fields `id`. - Possible filtering fields are `role`, `read`, `create`, `update`, `delete`, and `group_id`. - Searching will be performed on `role__name`.
         * @param {string} [groupId] Filter permissions by users role on particular group.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [permission] Filter by permission. Values can be comma separated. ex: 1,2
         * @param {string} [role] role
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolePermissionList(groupId?: string, ordering?: string, page?: number, pageSize?: number, permission?: string, role?: string, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedRolePermissionList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolePermissionList(groupId, ordering, page, pageSize, permission, role, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Viewset which allowed reading of Role-Permission combination.  - Possible ordering fields `id`. - Possible filtering fields are `role`, `read`, `create`, `update`, `delete`, and `group_id`. - Searching will be performed on `role__name`.
         * @param {number} id A unique integer value identifying this role permission.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolePermissionRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RolePermission>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolePermissionRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RolePermissionApi - factory interface
 * @export
 */
export const RolePermissionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RolePermissionApiFp(configuration)
    return {
        /**
         * Viewset which allowed reading of Role-Permission combination.  - Possible ordering fields `id`. - Possible filtering fields are `role`, `read`, `create`, `update`, `delete`, and `group_id`. - Searching will be performed on `role__name`.
         * @param {string} [groupId] Filter permissions by users role on particular group.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [permission] Filter by permission. Values can be comma separated. ex: 1,2
         * @param {string} [role] role
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolePermissionList(groupId?: string, ordering?: string, page?: number, pageSize?: number, permission?: string, role?: string, search?: string, options?: any): AxiosPromise<PaginatedRolePermissionList> {
            return localVarFp.rolePermissionList(groupId, ordering, page, pageSize, permission, role, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Viewset which allowed reading of Role-Permission combination.  - Possible ordering fields `id`. - Possible filtering fields are `role`, `read`, `create`, `update`, `delete`, and `group_id`. - Searching will be performed on `role__name`.
         * @param {number} id A unique integer value identifying this role permission.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolePermissionRetrieve(id: number, options?: any): AxiosPromise<RolePermission> {
            return localVarFp.rolePermissionRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RolePermissionApi - object-oriented interface
 * @export
 * @class RolePermissionApi
 * @extends {BaseAPI}
 */
export class RolePermissionApi extends BaseAPI {
    /**
     * Viewset which allowed reading of Role-Permission combination.  - Possible ordering fields `id`. - Possible filtering fields are `role`, `read`, `create`, `update`, `delete`, and `group_id`. - Searching will be performed on `role__name`.
     * @param {string} [groupId] Filter permissions by users role on particular group.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [permission] Filter by permission. Values can be comma separated. ex: 1,2
     * @param {string} [role] role
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolePermissionApi
     */
    public rolePermissionList(groupId?: string, ordering?: string, page?: number, pageSize?: number, permission?: string, role?: string, search?: string, options?: AxiosRequestConfig) {
        return RolePermissionApiFp(this.configuration).rolePermissionList(groupId, ordering, page, pageSize, permission, role, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Viewset which allowed reading of Role-Permission combination.  - Possible ordering fields `id`. - Possible filtering fields are `role`, `read`, `create`, `update`, `delete`, and `group_id`. - Searching will be performed on `role__name`.
     * @param {number} id A unique integer value identifying this role permission.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolePermissionApi
     */
    public rolePermissionRetrieve(id: number, options?: AxiosRequestConfig) {
        return RolePermissionApiFp(this.configuration).rolePermissionRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SchemaApi - axios parameter creator
 * @export
 */
export const SchemaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
         * @param {'json' | 'yaml'} [format] 
         * @param {'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant'} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemaRetrieve: async (format?: 'json' | 'yaml', lang?: 'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/schema/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchemaApi - functional programming interface
 * @export
 */
export const SchemaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchemaApiAxiosParamCreator(configuration)
    return {
        /**
         * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
         * @param {'json' | 'yaml'} [format] 
         * @param {'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant'} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schemaRetrieve(format?: 'json' | 'yaml', lang?: 'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schemaRetrieve(format, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SchemaApi - factory interface
 * @export
 */
export const SchemaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchemaApiFp(configuration)
    return {
        /**
         * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
         * @param {'json' | 'yaml'} [format] 
         * @param {'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant'} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemaRetrieve(format?: 'json' | 'yaml', lang?: 'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant', options?: any): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.schemaRetrieve(format, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchemaApi - object-oriented interface
 * @export
 * @class SchemaApi
 * @extends {BaseAPI}
 */
export class SchemaApi extends BaseAPI {
    /**
     * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
     * @param {'json' | 'yaml'} [format] 
     * @param {'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant'} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemaApi
     */
    public schemaRetrieve(format?: 'json' | 'yaml', lang?: 'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant', options?: AxiosRequestConfig) {
        return SchemaApiFp(this.configuration).schemaRetrieve(format, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ServiceErrorSettingApi - axios parameter creator
 * @export
 */
export const ServiceErrorSettingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows service error settings.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceErrorSettingList: async (page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/service_error_setting/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows service error settings.
         * @param {number} id A unique integer value identifying this service error setting.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceErrorSettingRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('serviceErrorSettingRetrieve', 'id', id)
            const localVarPath = `/api/service_error_setting/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceErrorSettingApi - functional programming interface
 * @export
 */
export const ServiceErrorSettingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceErrorSettingApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows service error settings.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serviceErrorSettingList(page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedServiceErrorSettingList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serviceErrorSettingList(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows service error settings.
         * @param {number} id A unique integer value identifying this service error setting.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serviceErrorSettingRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceErrorSetting>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serviceErrorSettingRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ServiceErrorSettingApi - factory interface
 * @export
 */
export const ServiceErrorSettingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceErrorSettingApiFp(configuration)
    return {
        /**
         * API endpoint that allows service error settings.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceErrorSettingList(page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedServiceErrorSettingList> {
            return localVarFp.serviceErrorSettingList(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows service error settings.
         * @param {number} id A unique integer value identifying this service error setting.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceErrorSettingRetrieve(id: number, options?: any): AxiosPromise<ServiceErrorSetting> {
            return localVarFp.serviceErrorSettingRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceErrorSettingApi - object-oriented interface
 * @export
 * @class ServiceErrorSettingApi
 * @extends {BaseAPI}
 */
export class ServiceErrorSettingApi extends BaseAPI {
    /**
     * API endpoint that allows service error settings.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceErrorSettingApi
     */
    public serviceErrorSettingList(page?: number, pageSize?: number, options?: AxiosRequestConfig) {
        return ServiceErrorSettingApiFp(this.configuration).serviceErrorSettingList(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows service error settings.
     * @param {number} id A unique integer value identifying this service error setting.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceErrorSettingApi
     */
    public serviceErrorSettingRetrieve(id: number, options?: AxiosRequestConfig) {
        return ServiceErrorSettingApiFp(this.configuration).serviceErrorSettingRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SwitchSiteApi - axios parameter creator
 * @export
 */
export const SwitchSiteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SwitchSiteRequest} switchSiteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchSiteCreate: async (switchSiteRequest: SwitchSiteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'switchSiteRequest' is not null or undefined
            assertParamExists('switchSiteCreate', 'switchSiteRequest', switchSiteRequest)
            const localVarPath = `/api/switch_site/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(switchSiteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SwitchSiteApi - functional programming interface
 * @export
 */
export const SwitchSiteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SwitchSiteApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {SwitchSiteRequest} switchSiteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async switchSiteCreate(switchSiteRequest: SwitchSiteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SwitchSite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.switchSiteCreate(switchSiteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SwitchSiteApi - factory interface
 * @export
 */
export const SwitchSiteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SwitchSiteApiFp(configuration)
    return {
        /**
         * 
         * @param {SwitchSiteRequest} switchSiteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchSiteCreate(switchSiteRequest: SwitchSiteRequest, options?: any): AxiosPromise<SwitchSite> {
            return localVarFp.switchSiteCreate(switchSiteRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SwitchSiteApi - object-oriented interface
 * @export
 * @class SwitchSiteApi
 * @extends {BaseAPI}
 */
export class SwitchSiteApi extends BaseAPI {
    /**
     * 
     * @param {SwitchSiteRequest} switchSiteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SwitchSiteApi
     */
    public switchSiteCreate(switchSiteRequest: SwitchSiteRequest, options?: AxiosRequestConfig) {
        return SwitchSiteApiFp(this.configuration).switchSiteCreate(switchSiteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TaskProgressApi - axios parameter creator
 * @export
 */
export const TaskProgressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that returns whether an Async job is finished, and what to do with the job.
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskProgressRetrieve: async (taskId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('taskProgressRetrieve', 'taskId', taskId)
            const localVarPath = `/api/task_progress/{task_id}`
                .replace(`{${"task_id"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaskProgressApi - functional programming interface
 * @export
 */
export const TaskProgressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaskProgressApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that returns whether an Async job is finished, and what to do with the job.
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taskProgressRetrieve(taskId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taskProgressRetrieve(taskId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TaskProgressApi - factory interface
 * @export
 */
export const TaskProgressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaskProgressApiFp(configuration)
    return {
        /**
         * API endpoint that returns whether an Async job is finished, and what to do with the job.
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskProgressRetrieve(taskId: string, options?: any): AxiosPromise<void> {
            return localVarFp.taskProgressRetrieve(taskId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaskProgressApi - object-oriented interface
 * @export
 * @class TaskProgressApi
 * @extends {BaseAPI}
 */
export class TaskProgressApi extends BaseAPI {
    /**
     * API endpoint that returns whether an Async job is finished, and what to do with the job.
     * @param {string} taskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskProgressApi
     */
    public taskProgressRetrieve(taskId: string, options?: AxiosRequestConfig) {
        return TaskProgressApiFp(this.configuration).taskProgressRetrieve(taskId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TokenApi - axios parameter creator
 * @export
 */
export const TokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Takes a set of user credentials and returns an access/refresh JWT pair.  The input username/password in Json is straightforward. For now they are checked against the fields in `CustomUser` model. Later on with Benefit One Platform Integration we\'ll send the creds to BOF for verifying.  The response is an access/refresh JWT token pair. Client wil use the access token to access various resources. The access token is set to expire quickly (currently 1 hour) for security reason. If the user is still active, client will use the refresh token to call the `refresh` API, and get a new pair of tokens. So it\'s transparent to the user: As long as they are active, they are always logged in. Once they become inactive, the tokens will timeout and the user will need to login again.
         * @param {TokenObtainPairRequest} tokenObtainPairRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenCreate: async (tokenObtainPairRequest: TokenObtainPairRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenObtainPairRequest' is not null or undefined
            assertParamExists('tokenCreate', 'tokenObtainPairRequest', tokenObtainPairRequest)
            const localVarPath = `/api/token/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenObtainPairRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Takes a refresh JWT and returns an access/refresh JWT pair if the refresh token is valid.  Details are in the `/api/token/` API doc.
         * @param {TokenRefreshRequest} tokenRefreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenRefreshCreate: async (tokenRefreshRequest: TokenRefreshRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenRefreshRequest' is not null or undefined
            assertParamExists('tokenRefreshCreate', 'tokenRefreshRequest', tokenRefreshRequest)
            const localVarPath = `/api/token/refresh/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenRefreshRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TokenApi - functional programming interface
 * @export
 */
export const TokenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TokenApiAxiosParamCreator(configuration)
    return {
        /**
         * Takes a set of user credentials and returns an access/refresh JWT pair.  The input username/password in Json is straightforward. For now they are checked against the fields in `CustomUser` model. Later on with Benefit One Platform Integration we\'ll send the creds to BOF for verifying.  The response is an access/refresh JWT token pair. Client wil use the access token to access various resources. The access token is set to expire quickly (currently 1 hour) for security reason. If the user is still active, client will use the refresh token to call the `refresh` API, and get a new pair of tokens. So it\'s transparent to the user: As long as they are active, they are always logged in. Once they become inactive, the tokens will timeout and the user will need to login again.
         * @param {TokenObtainPairRequest} tokenObtainPairRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenCreate(tokenObtainPairRequest: TokenObtainPairRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RicAuthTokenObtainResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenCreate(tokenObtainPairRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Takes a refresh JWT and returns an access/refresh JWT pair if the refresh token is valid.  Details are in the `/api/token/` API doc.
         * @param {TokenRefreshRequest} tokenRefreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenRefreshCreate(tokenRefreshRequest: TokenRefreshRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RicAuthTokenObtainResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenRefreshCreate(tokenRefreshRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TokenApi - factory interface
 * @export
 */
export const TokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TokenApiFp(configuration)
    return {
        /**
         * Takes a set of user credentials and returns an access/refresh JWT pair.  The input username/password in Json is straightforward. For now they are checked against the fields in `CustomUser` model. Later on with Benefit One Platform Integration we\'ll send the creds to BOF for verifying.  The response is an access/refresh JWT token pair. Client wil use the access token to access various resources. The access token is set to expire quickly (currently 1 hour) for security reason. If the user is still active, client will use the refresh token to call the `refresh` API, and get a new pair of tokens. So it\'s transparent to the user: As long as they are active, they are always logged in. Once they become inactive, the tokens will timeout and the user will need to login again.
         * @param {TokenObtainPairRequest} tokenObtainPairRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenCreate(tokenObtainPairRequest: TokenObtainPairRequest, options?: any): AxiosPromise<RicAuthTokenObtainResponse> {
            return localVarFp.tokenCreate(tokenObtainPairRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Takes a refresh JWT and returns an access/refresh JWT pair if the refresh token is valid.  Details are in the `/api/token/` API doc.
         * @param {TokenRefreshRequest} tokenRefreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenRefreshCreate(tokenRefreshRequest: TokenRefreshRequest, options?: any): AxiosPromise<RicAuthTokenObtainResponse> {
            return localVarFp.tokenRefreshCreate(tokenRefreshRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TokenApi - object-oriented interface
 * @export
 * @class TokenApi
 * @extends {BaseAPI}
 */
export class TokenApi extends BaseAPI {
    /**
     * Takes a set of user credentials and returns an access/refresh JWT pair.  The input username/password in Json is straightforward. For now they are checked against the fields in `CustomUser` model. Later on with Benefit One Platform Integration we\'ll send the creds to BOF for verifying.  The response is an access/refresh JWT token pair. Client wil use the access token to access various resources. The access token is set to expire quickly (currently 1 hour) for security reason. If the user is still active, client will use the refresh token to call the `refresh` API, and get a new pair of tokens. So it\'s transparent to the user: As long as they are active, they are always logged in. Once they become inactive, the tokens will timeout and the user will need to login again.
     * @param {TokenObtainPairRequest} tokenObtainPairRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    public tokenCreate(tokenObtainPairRequest: TokenObtainPairRequest, options?: AxiosRequestConfig) {
        return TokenApiFp(this.configuration).tokenCreate(tokenObtainPairRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Takes a refresh JWT and returns an access/refresh JWT pair if the refresh token is valid.  Details are in the `/api/token/` API doc.
     * @param {TokenRefreshRequest} tokenRefreshRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    public tokenRefreshCreate(tokenRefreshRequest: TokenRefreshRequest, options?: AxiosRequestConfig) {
        return TokenApiFp(this.configuration).tokenRefreshCreate(tokenRefreshRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserGroupRoleApi - axios parameter creator
 * @export
 */
export const UserGroupRoleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Viewset which allowed reading of User-Group-Role combination.  - Possible ordering fields are `id`, `group__name`, `group__code` `role__id`, `role__name`, `user`, `user__username`, and `user__katakana_name`. - Possible filtering fields are `group`, `user`, and `role`. - Searching will search the `group__name`, `group__code`, `role__name`, `user__katakana_name`, and `user__hiragana_name`.
         * @param {string} [adminOnly] Filter permissions by Admin Only Roles.
         * @param {string} [group] Filter permissions by group_id.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [role] role
         * @param {string} [search] A search term.
         * @param {string} [user] user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGroupRoleList: async (adminOnly?: string, group?: string, ordering?: string, page?: number, pageSize?: number, role?: string, search?: string, user?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user_group_role/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (adminOnly !== undefined) {
                localVarQueryParameter['admin_only'] = adminOnly;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Viewset which allowed reading of User-Group-Role combination.  - Possible ordering fields are `id`, `group__name`, `group__code` `role__id`, `role__name`, `user`, `user__username`, and `user__katakana_name`. - Possible filtering fields are `group`, `user`, and `role`. - Searching will search the `group__name`, `group__code`, `role__name`, `user__katakana_name`, and `user__hiragana_name`.
         * @param {number} id A unique integer value identifying this user group role.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGroupRoleRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userGroupRoleRetrieve', 'id', id)
            const localVarPath = `/api/user_group_role/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserGroupRoleApi - functional programming interface
 * @export
 */
export const UserGroupRoleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserGroupRoleApiAxiosParamCreator(configuration)
    return {
        /**
         * Viewset which allowed reading of User-Group-Role combination.  - Possible ordering fields are `id`, `group__name`, `group__code` `role__id`, `role__name`, `user`, `user__username`, and `user__katakana_name`. - Possible filtering fields are `group`, `user`, and `role`. - Searching will search the `group__name`, `group__code`, `role__name`, `user__katakana_name`, and `user__hiragana_name`.
         * @param {string} [adminOnly] Filter permissions by Admin Only Roles.
         * @param {string} [group] Filter permissions by group_id.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [role] role
         * @param {string} [search] A search term.
         * @param {string} [user] user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userGroupRoleList(adminOnly?: string, group?: string, ordering?: string, page?: number, pageSize?: number, role?: string, search?: string, user?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUserGroupRoleList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userGroupRoleList(adminOnly, group, ordering, page, pageSize, role, search, user, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Viewset which allowed reading of User-Group-Role combination.  - Possible ordering fields are `id`, `group__name`, `group__code` `role__id`, `role__name`, `user`, `user__username`, and `user__katakana_name`. - Possible filtering fields are `group`, `user`, and `role`. - Searching will search the `group__name`, `group__code`, `role__name`, `user__katakana_name`, and `user__hiragana_name`.
         * @param {number} id A unique integer value identifying this user group role.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userGroupRoleRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGroupRole>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userGroupRoleRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserGroupRoleApi - factory interface
 * @export
 */
export const UserGroupRoleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserGroupRoleApiFp(configuration)
    return {
        /**
         * Viewset which allowed reading of User-Group-Role combination.  - Possible ordering fields are `id`, `group__name`, `group__code` `role__id`, `role__name`, `user`, `user__username`, and `user__katakana_name`. - Possible filtering fields are `group`, `user`, and `role`. - Searching will search the `group__name`, `group__code`, `role__name`, `user__katakana_name`, and `user__hiragana_name`.
         * @param {string} [adminOnly] Filter permissions by Admin Only Roles.
         * @param {string} [group] Filter permissions by group_id.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [role] role
         * @param {string} [search] A search term.
         * @param {string} [user] user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGroupRoleList(adminOnly?: string, group?: string, ordering?: string, page?: number, pageSize?: number, role?: string, search?: string, user?: string, options?: any): AxiosPromise<PaginatedUserGroupRoleList> {
            return localVarFp.userGroupRoleList(adminOnly, group, ordering, page, pageSize, role, search, user, options).then((request) => request(axios, basePath));
        },
        /**
         * Viewset which allowed reading of User-Group-Role combination.  - Possible ordering fields are `id`, `group__name`, `group__code` `role__id`, `role__name`, `user`, `user__username`, and `user__katakana_name`. - Possible filtering fields are `group`, `user`, and `role`. - Searching will search the `group__name`, `group__code`, `role__name`, `user__katakana_name`, and `user__hiragana_name`.
         * @param {number} id A unique integer value identifying this user group role.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGroupRoleRetrieve(id: number, options?: any): AxiosPromise<UserGroupRole> {
            return localVarFp.userGroupRoleRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserGroupRoleApi - object-oriented interface
 * @export
 * @class UserGroupRoleApi
 * @extends {BaseAPI}
 */
export class UserGroupRoleApi extends BaseAPI {
    /**
     * Viewset which allowed reading of User-Group-Role combination.  - Possible ordering fields are `id`, `group__name`, `group__code` `role__id`, `role__name`, `user`, `user__username`, and `user__katakana_name`. - Possible filtering fields are `group`, `user`, and `role`. - Searching will search the `group__name`, `group__code`, `role__name`, `user__katakana_name`, and `user__hiragana_name`.
     * @param {string} [adminOnly] Filter permissions by Admin Only Roles.
     * @param {string} [group] Filter permissions by group_id.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [role] role
     * @param {string} [search] A search term.
     * @param {string} [user] user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupRoleApi
     */
    public userGroupRoleList(adminOnly?: string, group?: string, ordering?: string, page?: number, pageSize?: number, role?: string, search?: string, user?: string, options?: AxiosRequestConfig) {
        return UserGroupRoleApiFp(this.configuration).userGroupRoleList(adminOnly, group, ordering, page, pageSize, role, search, user, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Viewset which allowed reading of User-Group-Role combination.  - Possible ordering fields are `id`, `group__name`, `group__code` `role__id`, `role__name`, `user`, `user__username`, and `user__katakana_name`. - Possible filtering fields are `group`, `user`, and `role`. - Searching will search the `group__name`, `group__code`, `role__name`, `user__katakana_name`, and `user__hiragana_name`.
     * @param {number} id A unique integer value identifying this user group role.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupRoleApi
     */
    public userGroupRoleRetrieve(id: number, options?: AxiosRequestConfig) {
        return UserGroupRoleApiFp(this.configuration).userGroupRoleRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ValidationApiKeyApi - axios parameter creator
 * @export
 */
export const ValidationApiKeyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * APi use for the validating the APi-key access from the other client     like: -  RIC, RSS     They Use the Permission class that are defined and RIC_CLIENT HasKey it\'s work like the common system for RIC, RSS like Token Authentication :parameter     :key = Validation key that are passed in HTTP header     :path = APi path that are going to access     :domain =  the hosting domain from the bwowser     :request_from = request from is witch module try to request like ric, rss :return     is_valid_key : bool value
         * @param {ValidateApiKeyRequest} validateApiKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateApiKey: async (validateApiKeyRequest: ValidateApiKeyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validateApiKeyRequest' is not null or undefined
            assertParamExists('validateApiKey', 'validateApiKeyRequest', validateApiKeyRequest)
            const localVarPath = `/api/validation_api_key/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateApiKeyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidationApiKeyApi - functional programming interface
 * @export
 */
export const ValidationApiKeyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ValidationApiKeyApiAxiosParamCreator(configuration)
    return {
        /**
         * APi use for the validating the APi-key access from the other client     like: -  RIC, RSS     They Use the Permission class that are defined and RIC_CLIENT HasKey it\'s work like the common system for RIC, RSS like Token Authentication :parameter     :key = Validation key that are passed in HTTP header     :path = APi path that are going to access     :domain =  the hosting domain from the bwowser     :request_from = request from is witch module try to request like ric, rss :return     is_valid_key : bool value
         * @param {ValidateApiKeyRequest} validateApiKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateApiKey(validateApiKeyRequest: ValidateApiKeyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateApiKeyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateApiKey(validateApiKeyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ValidationApiKeyApi - factory interface
 * @export
 */
export const ValidationApiKeyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ValidationApiKeyApiFp(configuration)
    return {
        /**
         * APi use for the validating the APi-key access from the other client     like: -  RIC, RSS     They Use the Permission class that are defined and RIC_CLIENT HasKey it\'s work like the common system for RIC, RSS like Token Authentication :parameter     :key = Validation key that are passed in HTTP header     :path = APi path that are going to access     :domain =  the hosting domain from the bwowser     :request_from = request from is witch module try to request like ric, rss :return     is_valid_key : bool value
         * @param {ValidateApiKeyRequest} validateApiKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateApiKey(validateApiKeyRequest: ValidateApiKeyRequest, options?: any): AxiosPromise<ValidateApiKeyResponse> {
            return localVarFp.validateApiKey(validateApiKeyRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ValidationApiKeyApi - object-oriented interface
 * @export
 * @class ValidationApiKeyApi
 * @extends {BaseAPI}
 */
export class ValidationApiKeyApi extends BaseAPI {
    /**
     * APi use for the validating the APi-key access from the other client     like: -  RIC, RSS     They Use the Permission class that are defined and RIC_CLIENT HasKey it\'s work like the common system for RIC, RSS like Token Authentication :parameter     :key = Validation key that are passed in HTTP header     :path = APi path that are going to access     :domain =  the hosting domain from the bwowser     :request_from = request from is witch module try to request like ric, rss :return     is_valid_key : bool value
     * @param {ValidateApiKeyRequest} validateApiKeyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApiKeyApi
     */
    public validateApiKey(validateApiKeyRequest: ValidateApiKeyRequest, options?: AxiosRequestConfig) {
        return ValidationApiKeyApiFp(this.configuration).validateApiKey(validateApiKeyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


